/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prettier/prettier */
/* eslint-disable no-empty */
/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import {
  Box,
  Button,
  Divider,
  Popover,
  MenuItem,
  Checkbox,
  TextField,
  IconButton,
  Typography,
  ListItemText,
  Autocomplete,
  TableContainer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider as MuiDivider,
  Modal,
  InputAdornment
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import {
  roleNameFormatter,
  unixToHumanReadable,
  GroupBasedRoleFormatter
} from '../../components/common';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { API } from '../../../../api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useProgramContext } from '../../../../hooks/useProgramContext';
// import Upvotes from '../../components/Upvotes';
// import MatchFilter from './components/MatchFilter';
import RoleTypeTag from '../../components/RoleTypeTag';
import ChatProfile from '../chat/chat-main/ChatProfile';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useModule } from '../../../../utils/useModule';
import RecruitNewMentor from '../home/RecruitNewMentor';
// import MyPagination from '../../components/MyPagination';
import ChatAvatarComponent from '../chat/ChatAvatarComponent';
import AssignMatchPopup1 from './components/AssignMatchPopup1';
import AssignMatchPopup2 from './components/AssignMatchPopup2';
import ConfirmationPopup from './components/ConfirmationPopup';
import MatchDetailsPopup from './components/MatchDetailsPopup';
import MatchReasoningPopup from './components/MatchReasoningPopup';
import MatchDeleteDialog from './components/MatchDeleteDialog';
import MenteeProfileModal from '../home/MentorDash/Components/MenteeProfileModal';
import DosenButton from '../../../../components/ui/Buttons/DosenButton';
import DosenTooltip from '../../../../components/ui/DosenTooltip';
import ElliottWorking from '../../../../components/ui/ElliottWorking';
import { Bone } from '../../../../components/ui/DashboardSkeletons';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CheckIcon from '@mui/icons-material/Check';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { CommonStyle, adminPanel } from '../../../../utils/muiStyle';
import { PreviewIcon, ProfilePersonIcon } from '../../../../utils/Icons';
//import ExportButton from '../Program/components/program tabs/ExportButton';
import { setMessageAuto } from '../../../../redux/slices/AutoMatchMessage';
//import ExportPopover from '../Program/components/program tabs/ExportPopover';
import { fetchMatches, matchesActions, type GroupedMatchItem } from '../../../../redux/slices/getAllMatches/getAllMatchesSlice';
import { eventTracking, events, attributeKeys } from '../../../../utils/amplitude';
import SearchIcon from '@mui/icons-material/Search';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import DosenAutocomplete from '../../components/DosenAutocomplete';
import DosenInput from '../../components/DosenInput';
import { isMemberRole, useMemberWord, type MemberRole as MemberRoleCode } from '../../../../utils/memberTypeLabels';

interface MatchingFields {
  gender: boolean;
  firstGenStudent: boolean;
  ethnicity: boolean;
  disability: boolean;
  hobbies: boolean;
  major: boolean;
  university: boolean;
  industry: boolean;
  title: boolean;
  topics: boolean;
  industries: boolean;
  objectives: boolean;
}

interface SelectMentorsProps {
  memberList: Array<{
    displayName: string;
    role: string;
    headshot: string;
    major: boolean;
    university: boolean;
    industry: boolean;
    title: boolean;
    topics: boolean;
    industries: boolean;
    // Add other properties as needed
  }>;
  hasAnyTrueValue: boolean;
  assignIdFunction: (selectedOption: any) => void;
  setSelectValueMentor: React.Dispatch<React.SetStateAction<boolean>>;
  setMentorId: React.Dispatch<React.SetStateAction<string>>;
  setMenteeId: React.Dispatch<React.SetStateAction<string>>;
}

interface AIFieldComparison {
  field: string;
  reasoning: string;
}

interface Recommendation {
  role: string;
  searchQuery: { field: string; value: string; match: string }[];
  matchedFieldsCount: number;
  mentorId: string;
  menteeId: string;
  headshot: string;
  displayName: string;
  bio: string;
  aiReasoning?: string;
  aiScore?: number;
  aiOverallAssessment?: string;
  aiFieldComparisons?: AIFieldComparison[];
  name?: string;
  category?: string;
  matchCount?: number;
  departments?: string[];
}

interface DataItem {
  message: string;
  id: string;
  data: {
    grpId: string;
    isConfirmed: boolean;
    matchStatus: string;
    futureCalls: number;
    pastCalls: number;
    lastConnection: any;
    id: string;
    searchQuery: {
      field: string;
      value: string;
      isMatched: boolean;
    }[];
    // mentee: {
    //   bio: {
    //     education: {
    //       university: string;
    //       major: string;
    //       graduationDate: string;
    //     };
    //     workHistory: {
    //       companyName: string;
    //       role: string;
    //     };
    //   };
    //   displayName: string;
    //   id: string;
    //   headshot: string;
    //   goalProgress: number;
    // };
    // mentor: {
    //   bio: {
    //     workHistory: {
    //       companyName: string;
    //       role: string;
    //     };
    //     education: {
    //       university: string;
    //       major: string;
    //       graduationDate: string;
    //     };
    //   };
    //   displayName: string;
    //   id: string;
    //   headshot: string;
    // };
  };
  mentee: {
    bio: {
      education: {
        university: string;
        major: string;
        graduationDate: string;
      };
      workHistory: {
        companyName: string;
        role: string;
      };
    };
    displayName: string;
    id: string;
    headshot: string;
    goalProgress: number;
  };
  mentor: {
    bio: {
      workHistory: {
        companyName: string;
        role: string;
      };
      education: {
        university: string;
        major: string;
        graduationDate: string;
      };
    };
    displayName: string;
    id: string;
    headshot: string;
  };
  isConfirmed: boolean;
  matchStatus: string;
}

type MemberRole = 'Mentor' | 'Mentee';

interface MemberMatchEntry {
  match: any;
  counterpart: any;
  counterpartRole: MemberRole;
  statusLabel: string;
  statusColor: string;
  objectivesLabel: string;
}

interface MemberEntry {
  id: string;
  role: MemberRole;
  displayName: string;
  headshot?: string;
  bio?: any;
  matches: MemberMatchEntry[];
}

const matchGridTemplate =
  '24px minmax(180px, 2fr) minmax(160px, 1.5fr) minmax(140px, 1fr) minmax(120px, 1fr) minmax(110px, 1fr) minmax(110px, 1fr) minmax(150px, 1.1fr) 48px';

const initialMatchingFields: MatchingFields = {
  gender: false,
  firstGenStudent: false,
  ethnicity: false,
  disability: false,
  hobbies: false,
  major: false,
  university: false,
  industry: false,
  title: false,
  topics: false,
  industries: false,
  objectives: false
};

/** Select member field */
const SelectMentors: React.FC<SelectMentorsProps> = ({
  memberList,
  hasAnyTrueValue,
  setMentorId,
  setMenteeId,
  assignIdFunction,
  setSelectValueMentor
}) => {
  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor');
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee');

  const [search, setSearch] = useState('');
  const [selectedId, setSelectedId] = useState<string | null>(null);

  // 🔎 filtra lista
  const filteredList = useMemo(() => {
    if (!search.trim()) return memberList;
    return memberList.filter((item) =>
      item.displayName.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, memberList]);

  const handleSelect = (option: any) => {
    const isSelected = selectedId === option._id;

    if (isSelected) {
      // desmarcar
      setSelectedId(null);
      setMentorId('');
      setMenteeId('');
      setSelectValueMentor(false);
      return;
    }

    // marcar novo
    setSelectedId(option._id);
    assignIdFunction(option);
    setSelectValueMentor(true);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} width="100%" sx={{backgroundColor: 'black', color: 'white'}}>
      {/* 🔎 Search bar */}
      <DosenInput
        placeholder="Search..."
        value={search}
        disabled={hasAnyTrueValue}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
      />

      {/* 📄 Lista de opções */}
      <Box
        sx={{
          maxHeight: 320,
          overflowY: 'auto',
          borderRadius: '8px',
          border: '1px solid #2A2A2A',
          background: '#121212',
          p: 1
        }}
      >
        {filteredList.map((option: any) => {
          const isSelected = selectedId === option._id;

          return (
            <MenuItem
              key={option._id}
              onClick={() => !hasAnyTrueValue && handleSelect(option)}
              disabled={hasAnyTrueValue}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                cursor: hasAnyTrueValue ? 'not-allowed' : 'pointer',
                py: 1.2
              }}
            >
              {/* ⬅️ Checkbox */}
              <Checkbox checked={isSelected} />

              {/* Conteúdo customizado */}
              <Box
                gap={'8px'}
                display={'flex'}
                alignItems={'center'}
                width="calc(100% - 60px)"
              >
                <ChatAvatarComponent
                  image={option.headshot}
                  firstLetter={option.displayName?.slice(0, 1)}
                  width={'40px'}
                  height={'40px'}
                  cursor="pointer"
                  type="noStatus"
                />

                <Box width="calc(100% - 64px)">
                  <Box display={'flex'} gap={'8px'}>
                    <Typography variant="h5" noWrap>
                      {option.displayName}
                    </Typography>
                    <RoleTypeTag category={option.role} />
                  </Box>
                  <Typography noWrap>Testing bio</Typography>
                </Box>
              </Box>
            </MenuItem>
          );
        })}
      </Box>
    </Box>
  );
};


const MatchesMainPage = ({ onOpenSettings }: { onOpenSettings?: () => void }) => {
  /** Common Design classes */
  const CommonClass = CommonStyle();
  const { isMentorship } = useModule();
  const ImageNameBox = `${CommonClass.gap} ${CommonClass.displayFlex} ${CommonClass.alignItemsCenter}`;
  const { groupId: grpId, orgId, coId, location: programLocation } = useProgramContext();
  const programNameMatches =
    useAppSelector((state) => state.groupDetails.data?.name || state.selectedGroup.data?.name) || '';
  const aiMatchingSettings = useAppSelector((state) => state.groupDetails.data?.matchesSettings?.aiMatching);
  const isAiMatchingEnabled = aiMatchingSettings?.enabled === true;

  const dispatch: any = useAppDispatch();
  const w = useMemberWord();
  const groupUsers = useAppSelector((state) => state.groupUsers);
  const allMatchesData = useAppSelector((state) => state?.getAllMatchesList?.data);
  const loading = useAppSelector((state) => state?.getAllMatchesList?.loading);
  const error = useAppSelector((state) => state?.getAllMatchesList?.error);
  const messageAutoMatch = useAppSelector((state) => state?.message?.message);
  // Pending matches for the confirmation dialog. The page fetches the grouped view, which has no flat
  // matches[]: counting that said "You have 0 match(es)" while the server held pending ones. A match is
  // listed under both of its people, so ids are counted once.
  const matchesCount = (() => {
    if (allMatchesData?.view === 'grouped' && Array.isArray(allMatchesData.groupedMatches)) {
      const pending = new Set<string>();
      for (const row of allMatchesData.groupedMatches) {
        for (const m of row?.matches || []) {
          if (m && !m.isConfirmed && m.matchStatus !== 'Inactive') pending.add(String(m.id || m.matchId));
        }
      }
      return pending.size;
    }
    return (
      (allMatchesData &&
        Array.isArray(allMatchesData.matches) &&
        allMatchesData.matches.filter((match) => match && !match.isConfirmed).length) ||
      0
    );
  })();
  const [dataArray, setDataArray] = useState<DataItem[]>([]);
  const confirmedCount = dataArray.filter((item) => !item?.data?.isConfirmed).length;
  const [matchingFields, setMatchingFields] = useState<MatchingFields>(initialMatchingFields);
  const [recommendations, setRecommendations] = useState<Recommendation[]>([]);
  const [suggestions, setSuggestions] = useState<Recommendation[]>([]);
  const [selectedRecommendation, setSelectedRecommendation] = useState<Recommendation | null>(null);
  const [openAssignMentor, setOpenAssignMentor] = useState(false);
  const [openAssignMentorSecond, setOpenAssignMentorSecond] = useState(false);
  const [userId, setUserId] = useState<string>('');
  let [menteeId, setMenteeId] = useState('');
  let [mentorId, setMentorId] = useState('');
  const [manualTriggerRole, setManualTriggerRole] = useState<MemberRole | null>(null);
  const [manualTriggerId, setManualTriggerId] = useState('');
  const [action, setAction] = useState('');
  const apiAssigneeRole = action === 'Assign Mentor' ? 'Mentee' : action === 'Assign Mentee' ? 'Mentor' : 'Mentee';
  const [memberList, setMemberList] = useState<any[]>([]);
  const [selectValueMentor, setSelectValueMentor] = useState(false);
  const [openMatchDetails, setOpenMatchDetails] = useState(false);
  const [modelConfirmMatch, setModelConfirmMatch] = useState(false);
  const [confirmMatchId, setConfirmMatchId] = useState('');
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  // AI Match cards start collapsed; this tracks which ones the admin has expanded.
  const [expandedAiCards, setExpandedAiCards] = useState<Record<string, boolean>>({});
  const [loaderFirstPopup, setLoaderFirstPopup] = useState(false);
  const [loaderFirstPopup1, setLoaderFirstPopup1] = useState(false);
  const [anchorElConfirm, setAnchorElConfirm] = React.useState<HTMLButtonElement | null>(null);
  const [maxMatchCountMentee, setMatchCountMentee] = useState<number | undefined>();
  const [maxMatchCountMentor, setMatchCountMentor] = useState<number | undefined>();
  const openConfirm = Boolean(anchorElConfirm);
  const idConfirm = openConfirm ? 'simple-popover' : undefined;
  /** Pagination & search (same params as ProgramUsers members) */
  const initialPageSize = 30;
  const nextPageSize = 20;
  const [pageNumber, setPageNumber] = useState(1);
  const [searchInput, setSearchInput] = useState('');
  const [searchName, setSearchName] = useState('');
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const listContainerRef = useRef<HTMLDivElement | null>(null);
  const loadMoreSentinelRef = useRef<HTMLDivElement | null>(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [matchDetails, setMatchDetails] = useState();
  const [matchSingle, setMatchSingle] = useState<any>();
  const [activeUserId, setActiveUserId] = useState<any>();
  const [activeUserDetails, setActiveUserDetails] = useState<any>();
  const [latestEducation, setLatestEducation] = useState<any>();
  const [latestWorkHistory, setLatestWorkHistory] = useState<any>();
  const [openProfile, setOpenProfile] = useState(false);
  const [matchDetailsLoader, setMatchDetailsLoader] = useState(false);
  const [loadingUserDetails, setLoadingUserDetails] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<string>();
  const [isAutoConfirming, setIsAutoConfirming] = useState(false);
  const [openMenteeProfileModal, setOpenMenteeProfileModal] = useState(false);
  const [profileModalUser, setProfileModalUser] = useState<any>(null);
  const [matcheeProfileUser, setMatcheeProfileUser] = useState<any>(null);
  const [openManualInvite, setOpenManualInvite] = useState(false);
  const [manualInviteTab, setManualInviteTab] = useState<'auto' | 'manual' | 'ai'>('auto');
  const [aiRecommendations, setAiRecommendations] = useState<any[]>([]);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiEmptyMessage, setAiEmptyMessage] = useState<string | null>(null);
  const [aiErrorMessage, setAiErrorMessage] = useState<string | null>(null);
  const [manualSearchValue, setManualSearchValue] = useState('');
  const [manualAssignLoading, setManualAssignLoading] = useState(false);
  const [learningObjectives, setLearningObjectives] = useState<{ id: string; objective: string }[]>([]);
  const [selectedObjectivesByCandidate, setSelectedObjectivesByCandidate] = useState<Record<string, string[]>>({});
  // AI Match tab: ids of recommendations the admin has checked to assign.
  const [selectedAiCandidateIds, setSelectedAiCandidateIds] = useState<string[]>([]);
  // Match Reasoning modal (opened from the matches 3-dots menu for an AI-assigned match).
  const [openMatchReasoning, setOpenMatchReasoning] = useState(false);
  const [autoSuggestedMentees, setAutoSuggestedMentees] = useState<any[]>([]);
  // Why there are no suggestions, when the server says (a member at their match limit answers 400).
  const [autoSuggestionsError, setAutoSuggestionsError] = useState('');
  const [autoSuggestionsLoading, setAutoSuggestionsLoading] = useState(false);
  const manualListPageSize = 20;
  const [visibleMenteesCount, setVisibleMenteesCount] = useState(manualListPageSize);
  const [activeTab, setActiveTab] = useState<'mentors' | 'mentees' | 'matches'>('matches');
  // const [anchorExport, setAnchorExport] = React.useState<HTMLButtonElement | null>(null);
  // const [isClicked, setIsClicked] = useState(false);
  const classs = adminPanel();
  const copiedUserDetails = {
    ...activeUserDetails,
    id: activeUserDetails?.personal_details,
    bio: { education: latestEducation, workHistory: latestWorkHistory },
    education: { updatedData: activeUserDetails?.professional_details?.education },
    workHistory: { updatedData: activeUserDetails?.professional_details?.workHistory }
    // digital_intro: activeUserDetails?.digital_intro?.videoUrl
  };

  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor'); // Mentor
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee'); // Mentee
  const [openRecruitMentor, setOpenRecruitMentor] = useState(false);
  const [isAssignPopup, setIsAssignPopup] = useState(false);
  const handleCloseMatchDetails = () => {
    setOpenMatchDetails(false);
    // setLoaderFirstPopup(false);
  };
  const handleOpenMatchDetails = async () => {
    setMatchDetails(undefined);
    setAnchorElConfirm(null);
    setOpenMatchDetails(true);
    setMatchDetailsLoader(true);
    try {
      const response = await API.getMatchProfile({
        orgId: orgId,
        confirmMatchId: confirmMatchId
      });
      if (response?.status === 200) {
        setMatchDetailsLoader(false);
        setMatchDetails(response?.data?.data);
      }
    } catch (error) {}
  };

  const handleOpenRecruitMentor = (isAssign: boolean) => {
    setIsAssignPopup(isAssign);
    setOpenRecruitMentor(true);
  };

  const handleCloseRecruitMentor = () => {
    setOpenRecruitMentor(false);
    setIsAssignPopup(false);
  };

  const handleOpenAssignForMember = (member: MemberEntry) => {
    handleOpenManualInvite(member);
  };

  const handleCloseAssignMentor = () => {
    setOpenAssignMentor(false);
    setLoaderFirstPopup(false);
    setMatchingFields(initialMatchingFields);
    setLoaderFirstPopup1(false);
    setMentorId('');
    setMenteeId('');
    setSelectValueMentor(false);
  };

  const handleOpenManualInvite = (member: MemberEntry) => {
    setManualTriggerRole(member.role);
    setManualTriggerId(member.id);
    setSelectedObjectivesByCandidate({});
    setSelectedAiCandidateIds([]);
    setManualInviteTab('auto');
    setAutoSuggestionsLoading(true);
    setAutoSuggestedMentees([]);
    setOpenManualInvite(true);
  };

  const handleCloseManualInvite = () => {
    setOpenManualInvite(false);
    setManualSearchValue('');
    setSelectedObjectivesByCandidate({});
    setSelectedAiCandidateIds([]);
    setManualAssignLoading(false);
    setManualInviteTab('auto');
    setAiRecommendations([]);
    setAiEmptyMessage(null);
    setAiErrorMessage(null);
  };

  const fetchAllMembers = async () => {
    const effectiveUserId = userId || activeUserId;
    if (!effectiveUserId) return;
    const response = await API.getListToAssignMatch({
      orgId: orgId,
      userId: effectiveUserId,
      grpId: grpId !== 'admin' ? grpId : coId,
      data: {
        assigneeRole: apiAssigneeRole
      },
      isMatchingFields: false
    });
    if (response?.data?.data) {
      setMemberList(response?.data?.data);
    }
  };

  const assignIdFunction = (selectedOption: any) => {
    if (selectedOption.role === 'Mentee') {
      // setAssigneeId(selectedOption?.menteeId);
      setMentorId(userId);
      setMenteeId(selectedOption?.menteeId);
    }
    if (selectedOption.role === 'Mentor') {
      // setAssigneeId(selectedOption?.mentorId);
      setMentorId(selectedOption?.mentorId);
      setMenteeId(userId);
    }
  };

  const handleOpenFindmentor = async (event: React.FormEvent) => {
    const hasTrueValue = Object.values(matchingFields).some((value) => value === true);
    const isSelectingFromList = selectValueMentor === true;

    if (!isSelectingFromList && !isMentorship && hasTrueValue === false) {
      toast.error('Please make a selection');
      return;
    }

    // selecting from list
    if (isSelectingFromList) {
      setLoaderFirstPopup(true);
      const response = await API.assignAMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          mentorId: mentorId,
          menteeId: menteeId,
          assigneeRole: apiAssigneeRole
        }
      });

      if (response?.status === 200) {
        setLoaderFirstPopup(false);

        const matchesData = response.data?.data
          ? Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data]
          : [];

        if (matchesData.length > 0) {
          setDataArray([...dataArray, ...matchesData]);

          matchesData.forEach((match: any) => {
            dispatch(
              matchesActions.updateMenteesMentors({
                menteeId: match.mentee?.userId,
                mentorId: match.mentor?.userId
              })
            );
          });

          // Auto confirm for manual match creation disabled per product requirement.
          // await confirmMatchesImmediately(matchesData);
        }
        eventTracking(events.matchCreated, {
          groupId: grpId,
          orgId,
          assigneeRole: apiAssigneeRole,
          matchSource: 'assignment-list',
          matchCount: matchesData.length
        });

        if (action === 'Assign Mentor') {
          toast.success(mentorRoleText + ' assigned successfully');
        }
        if (action === 'Assign Mentee') {
          toast.success(menteeRoleText + ' assigned successfully');
        }
      } else {
        setLoaderFirstPopup(false);
        toast.error('The match could not be assigned. Try again.');
      }
      setOpenAssignMentor(false);
      setMenteeId('');
      setMentorId('');
      setSelectValueMentor(false);
      return;
    }

    if (isMentorship) {
      setMatchingFields({
        ...initialMatchingFields,
        objectives: true
      });

      setLoaderFirstPopup(true);
      event.preventDefault();

      try {
        const response = await API.getListToAssignMatch({
          orgId: orgId,
          userId: userId || activeUserId,
          grpId: grpId !== 'admin' ? grpId : coId,
          data: {
            assigneeRole: apiAssigneeRole,
            matchingFields: {
              ...initialMatchingFields,
              objectives: true
            }
          },
          isMatchingFields: true
        });

        if (response?.status === 200) {
          setRecommendations(response.data?.data?.recommendations);
          setSuggestions(response.data?.data?.suggestions);
          setMenteeId(response.data?.data?.MenteeId);
          setMentorId(response.data?.data?.MentorId);
          setLoaderFirstPopup(false);
        } else {
          setLoaderFirstPopup(false);
          toast.error(response?.data?.message || 'Suggested matches could not be loaded. Try again.');
        }

        setOpenAssignMentorSecond(true);
        setOpenAssignMentor(false);
      } catch (error) {
        setLoaderFirstPopup(false);
        toast.error('Suggested matches could not be loaded. Try again.');
      }
      return;
    }

    if (hasTrueValue) {
      setLoaderFirstPopup(true);
      event.preventDefault();
      const response = await API.getListToAssignMatch({
        orgId: orgId,
        userId: userId || activeUserId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          assigneeRole: apiAssigneeRole,
          matchingFields
        },
        isMatchingFields: true
      });

      if (response?.status === 200) {
        setRecommendations(response.data?.data?.recommendations);
        setSuggestions(response.data?.data?.suggestions);
        setMenteeId(response.data?.data?.MenteeId);
        setMentorId(response.data?.data?.MentorId);
        setLoaderFirstPopup(false);
        setMatchingFields(initialMatchingFields);
      } else {
        setLoaderFirstPopup(false);
        setMatchingFields(initialMatchingFields);
        if (response?.status === 400) {
          toast.error('User has reached their maximum number of matches');
        }
      }

      setOpenAssignMentorSecond(true);
      setOpenAssignMentor(false);
    }
  };

  const handleClickOpenAutoMatch = () => {
    //   setOpen(true);
    setAction('Auto Match');
    setOpenAssignMentor(true);
  };

  const handelCloseAssineMatch = () => {
    setOpenAssignMentor(false);
    setOpenAssignMentorSecond(false);
    setLoaderFirstPopup(false);
    setLoaderFirstPopup1(false);
    setMentorId('');
    setMenteeId('');
    setSelectValueMentor(false);
  };

  const handleSubmitAssignMatch = async () => {
    setLoaderFirstPopup(true);

    // const searchQuery = selectedRecommendation?.searchQuery.map((query) => ({
    //   field: query.field,
    //   value: query.value,
    //   match: query.match
    // }));
    if (selectedRecommendation) {
      const response = await API.assignAMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          mentorId: action === 'Assign Mentor' ? selectedRecommendation?.mentorId : mentorId || activeUserId,
          menteeId: action === 'Assign Mentor' ? menteeId || activeUserId : selectedRecommendation?.menteeId,
          // searchQuery
          assigneeRole: apiAssigneeRole
        }
      });

      if (response?.status === 200) {
        setLoaderFirstPopup(false);
        const matchesData = response.data?.data
          ? Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data]
          : [];

        if (matchesData.length > 0) {
          setDataArray([...dataArray, ...matchesData]);

          matchesData.forEach((match: any) => {
            dispatch(
              matchesActions.updateMenteesMentors({
                menteeId: action === 'Assign Mentor' ? menteeId || activeUserId : match.mentee?.userId,
                mentorId: action === 'Assign Mentor' ? match.mentor?.userId : mentorId || activeUserId
              })
            );
          });

          await confirmMatchesImmediately(matchesData);
        }
        dispatch(
          fetchMatches({
            orgId,
            groupId: grpId !== 'admin' ? grpId : coId,
            name: searchName.trim() || undefined,
            pageNumber: 1,
            pageSize: initialPageSize
          })
        );
        eventTracking(events.matchCreated, {
          groupId: grpId,
          orgId,
          assigneeRole: apiAssigneeRole,
          matchSource: 'recommendation',
          matchCount: matchesData.length
        });
        if (action === 'Assign Mentor') {
          toast.success(mentorRoleText + ' assigned successfully');
        }
        if (action === 'Assign Mentee') {
          toast.success(menteeRoleText + ' assigned successfully');
        }
      } else {
        toast.error('The match could not be assigned. Try again.');
      }
    } else {
    }

    setOpenAssignMentor(false);
    setOpenAssignMentorSecond(false);
    setLoaderFirstPopup(false);
    setMenteeId('');
    setMentorId('');
  };

  const confirmMatchesImmediately = async (matches: any[]) => {
    const ids = matches
      .map((match) => match?.id || match?._id || _.get(match, 'data.id') || _.get(match, 'data._id'))
      .filter(Boolean);
    if (!ids.length) return;

    try {
      await Promise.all(
        ids.map((id) =>
          API.confirmMatch({
            orgId: orgId,
            grpId: grpId !== 'admin' ? grpId : coId,
            data: { id }
          })
        )
      );

      setDataArray((prev) =>
        prev.map((item) => {
          const itemId = item?.id  || _.get(item, 'data.id') || _.get(item, 'data._id');
          if (itemId && ids.includes(itemId)) {
            return { ...item, isConfirmed: true };
          }
          return item;
        })
      );

      ids.forEach((id) => dispatch(matchesActions.updateConfirmStatus(id)));
      eventTracking(events.userMatched, {
        [attributeKeys.programName]: programNameMatches,
        [attributeKeys.matchCreator]: 'Admin Created',
        [attributeKeys.matchFeature]: 'Manual',
        [attributeKeys.matchCount]: ids.length,
        grpId: grpId !== 'admin' ? grpId : coId
      });
    } catch (error) {
      toast.error('The match could not be confirmed automatically. Try again.');
    }
  };

  const handleConfirmMatch = async (id: string) => {
    setAnchorElConfirm(null);
    setConfirmMatchId(id);
    setModelConfirmMatch(true);
  };

  const handleOpenMatchPopover = async (id: string, event: React.MouseEvent<HTMLButtonElement>) => {
    let match: any = null;
    if (allMatchesData?.view === 'grouped' && Array.isArray(allMatchesData.groupedMatches)) {
      for (const row of allMatchesData.groupedMatches) {
        const m = row.matches?.find((ele: any) => ele.id === id || ele.matchId === id);
        if (m) {
          match = m;
          break;
        }
      }
    }
    if (!match) {
      match = allMatchesData?.matches?.find((ele: any) => ele.id === id);
    }
    if (!match) {
      match = dataArray.find((ele) => ele.id === id || _.get(ele, 'data.id') === id);
    }
    if (match) setMatchSingle(match);
    setConfirmMatchId(id);
    setAnchorElConfirm(event.currentTarget);
    setOpenProfile(false);
  };

  const handleCloseConfirmMatch = async () => {
    setModelConfirmMatch(false);
    setLoaderFirstPopup(false);
  };

  const handleConfirmAll = async () => {
    setLoaderFirstPopup1(true);
    try {
      const response = await API.confirmAllMatches({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId
      });

      if (response?.status === 200) {
        const updatedDataArray = dataArray.map((item) => {
          item.isConfirmed = true;
          return item;
        });
        eventTracking(events.matchByAdmin, {});
        setDataArray(updatedDataArray);

        dispatch(matchesActions.updateConfirmStatusAll());
        setLoaderFirstPopup1(false);
        setLoaderFirstPopup(false);
        toast.success('All matches are confirmed successfully');
        setAnchorElConfirm(null);
      } else {
        setLoaderFirstPopup1(false);
        setLoaderFirstPopup(false);
        toast.error('The matches could not be confirmed. Try again.');
      }
    } catch (error) {}
    setModelConfirmMatch(false);
  };

  const handelSubmitConfirmMatch = async () => {
    setLoaderFirstPopup(true);
    try {
      const response = await API.confirmMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: {
          id: confirmMatchId
        }
      });

      if (response?.status === 200) {
        eventTracking(events.matchByAdmin, {});
        eventTracking(events.userMatched, {
          [attributeKeys.programName]: programNameMatches,
          [attributeKeys.matchCreator]: 'Admin Created',
          [attributeKeys.matchFeature]: 'Manual',
          [attributeKeys.matchCount]: 1,
          grpId: grpId !== 'admin' ? grpId : coId,
          matchId: confirmMatchId
        });
        const updatedDataArray = dataArray.map((item) => {
          if (item.id === response?.data?.data?.id) {
            item.isConfirmed = true;
          }
          return item;
        });

        setDataArray(updatedDataArray);
        dispatch(matchesActions.updateConfirmStatus(response?.data?.data?.id));
        dispatch(
          fetchMatches({
            orgId,
            groupId: grpId !== 'admin' ? grpId : coId,
            name: searchName.trim() || undefined,
            pageNumber: 1,
            pageSize: initialPageSize
          })
        );
        setLoaderFirstPopup(false);
        toast.success('Match confirmed successfully');
        setAnchorElConfirm(null);
      } else {
        toast.error('The match could not be confirmed. Try again.');
        setLoaderFirstPopup(false);
      }
    } catch (error) {}
    setModelConfirmMatch(false);
  };

  const handelOpenProfile = (id: string) => {
    setSelectedUserId(id);
  };

  const getUserProfileDetails = async () => {
    if (selectedUserId) {
      try {
        setOpenProfile(false);
        const response = await API.getUserProfileInAGroup(grpId !== 'admin' ? grpId : coId, selectedUserId);
        if (response?.status === 200) {
          setActiveUserDetails(response?.data?.userDetails);
          setOpenProfile(true);
        } else {
          setOpenProfile(false);
          toast.error('Profile details could not be loaded. Refresh the page and try again.');
        }
        setSelectedUserId('');
      } catch (e) {
        setOpenProfile(false);
        toast.error('Profile details could not be loaded. Refresh the page and try again.');
      }
    }
  };

  const handleCloseConfirmPopover = () => {
    setAnchorElConfirm(null);
  };

  const getMaxMatches = async () => {
    try {
      const response = await API.getAllMatchesSetting({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId
      });

      if (response?.status === 200) {
        const { maxMatchesPerMentor, maxMatchesPerMentee } = response.data.data.matchesSettings;
        setMatchCountMentee(maxMatchesPerMentee);
        setMatchCountMentor(maxMatchesPerMentor);
      } else {
      }
    } catch (error) {
      toast.error('Match settings could not be loaded. Refresh the page and try again.');
    }
  };

  const handleOpendelete = () => {
    setOpenDelete(true);
    setAnchorElConfirm(null);
  };

  const handeleDeleteMatch = async () => {
    setDeleteLoader(true);
    try {
      const response = await API.removeMatch({
        orgId: orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        confirmMatchId: confirmMatchId
      });

      if (response?.status === 200) {
        setDeleteLoader(false);
        setOpenDelete(false);
        const updatedDataArray = dataArray.map((item) => {
          if (item.data.id === confirmMatchId) {
            item.data.matchStatus = 'Inactive';
          }
          return item;
        });
        setDataArray(updatedDataArray);
        dispatch(matchesActions.endMatch(confirmMatchId));
        dispatch(
          fetchMatches({
            orgId,
            groupId: grpId !== 'admin' ? grpId : coId,
            name: searchName.trim() || undefined,
            pageNumber: 1,
            pageSize: initialPageSize
          })
        );
        toast.success('Match ended successfully.');
      }
    } catch (error) {
      toast.error('The match could not be ended. Try again.');
    }
  };

  useEffect(() => {
    if (selectedUserId) {
      getUserProfileDetails();
    }
  }, [selectedUserId]);

  useEffect(() => {
    setLatestEducation(
      activeUserDetails?.professional_details?.education?.sort(
        (a: any, b: any) => b?.graduation_date - a?.graduation_date
      )[0]
    );
    setLatestWorkHistory(
      activeUserDetails?.professional_details?.workHistory
        ?.filter((a: any) => a.currentlyWorking === true)
        ?.sort((a: any, b: any) => b.start_date - a.start_date)[0]
    );
  }, [activeUserDetails]);

  useEffect(() => {
    getMaxMatches();
  }, []);

  useEffect(() => {
    if (openAssignMentor || openManualInvite) {
      fetchAllMembers();
    }
  }, [openAssignMentor, openManualInvite]);

  useEffect(() => {
    const fetchObjectives = async () => {
      try {
        const response = await API.getLearningObjectives({ grpId: grpId !== 'admin' ? grpId : coId, orgId });
        const rawObjectives =
          response.data?.data?.learningObjectives?.objectives ||
          response.data?.data?.learningObjectives?.data ||
          response.data?.data?.learningObjectives ||
          [];
        const normalized = (Array.isArray(rawObjectives) ? rawObjectives : [])
          .map((obj: any, index: number) => {
            if (typeof obj === 'string') {
              return { id: obj, objective: obj };
            }
            return {
              id: obj?.id || obj?._id || obj?.objectiveId || obj?.value || `objective-${index}`,
              objective: obj?.objective || obj?.title || obj?.name || obj?.label || 'Objective'
            };
          })
          .filter((obj) => Boolean(obj.id));
        setLearningObjectives(normalized);
      } catch (error) {
        setLearningObjectives([]);
      }
    };

    if (openManualInvite) {
      fetchObjectives();
    }
  }, [openManualInvite, grpId, coId, orgId]);

  useEffect(() => {
    const fetchAutoSuggested = async () => {
      if (!manualTriggerId || !manualTriggerRole) return;
      const assigneeRole = manualTriggerRole === 'Mentor' ? 'Mentor' : 'Mentee';
      setAutoSuggestionsLoading(true);
      setAutoSuggestionsError('');
      try {
        const response = await API.getListToAssignMatch({
          orgId,
          userId: manualTriggerId,
          grpId: grpId !== 'admin' ? grpId : coId,
          data: {
            assigneeRole,
            matchingFields: {
              ...initialMatchingFields,
              objectives: true
            }
          },
          isMatchingFields: true
        });
        const data = response?.data?.data;
        const recs = Array.isArray(data?.recommendations) ? data.recommendations : [];
        const suggs = Array.isArray(data?.suggestions) ? data.suggestions : [];
        const raw = recs.length || suggs.length ? [...recs, ...suggs] : (Array.isArray(data) ? data : []);
        const list = Array.isArray(raw) ? raw : [];
        const isTriggerMentor = manualTriggerRole === 'Mentor';
        const normalized = list
          .map((item: any) => {
            const mentor = item?.mentor ?? item;
            const mentee = item?.mentee || item?.user || item?.id || item;
            const candidate = isTriggerMentor ? mentee : mentor;
            const id =
              isTriggerMentor
                ? (item?.menteeId ?? mentee?.userId ?? mentee?.id ?? mentee?._id ?? item?.id ?? item?._id)
                : (item?.mentorId ?? mentor?.userId ?? mentor?.id ?? mentor?._id ?? item?.id ?? item?._id);
            if (!id || typeof id !== 'string') return null;
            const displayName =
              item?.displayName ?? candidate?.displayName ?? candidate?.name ?? item?.name ?? 'Unnamed';
            const headshot = item?.headshot ?? item?.image ?? candidate?.headshot ?? candidate?.image ?? '';
            const title =
              item?.bio?.workHistory?.role ??
              item?.professional_details?.workHistory?.role ??
              candidate?.bio?.workHistory?.role ??
              candidate?.professional_details?.workHistory?.role ??
              '';
            const company =
              item?.bio?.workHistory?.companyName ??
              item?.professional_details?.workHistory?.companyName ??
              candidate?.bio?.workHistory?.companyName ??
              candidate?.professional_details?.workHistory?.companyName ??
              '';
            const matchedObjectives =
              item?.matchedObjectives ??
              item?.objectives ??
              item?.learningObjectives ??
              candidate?.matchedObjectives ??
              candidate?.objectives ??
              candidate?.learningObjectives ??
              [];
            const role =
              item?.role ??
              candidate?.role ??
              candidate?.memberRole ??
              candidate?.userRole ??
              candidate?.type ??
              (isTriggerMentor ? 'Mentee' : 'Mentor');
            const matchCount = item?.matchCount ?? candidate?.matchCount ?? 0;
            return { id, displayName, headshot, title, company, matchedObjectives, role, matchCount };
          })
          .filter((item: any) => item != null && Boolean(item?.id));
        const deduped = Array.from(
          new Map(normalized.map((item: any) => [String(item.id), item])).values()
        );
        setAutoSuggestedMentees(deduped);
      } catch (error: any) {
        setAutoSuggestedMentees([]);
        // Keep the server's reason for a refusal ("Assignee has already reached the MaxMatchesLimit"):
        // the dialog said "No suggestions available." as if nobody fitted.
        const status = error?.response?.status;
        const message = error?.response?.data?.message;
        if (status >= 400 && status < 500 && typeof message === 'string') setAutoSuggestionsError(message);
      } finally {
        setAutoSuggestionsLoading(false);
      }
    };

    if (openManualInvite && manualInviteTab === 'auto') {
      fetchAutoSuggested();
    }
  }, [openManualInvite, manualInviteTab, manualTriggerId, manualTriggerRole, grpId, coId, orgId]);


  const handleSubmitAutoMatch = async () => {
    setLoaderFirstPopup(true);
    const response = await API.autoMatch({
      orgId: orgId,
      grpId: grpId !== 'admin' ? grpId : coId,
      data: {
        maxMatchesPerMentor: maxMatchCountMentor,
        maxMatchesPerMentee: maxMatchCountMentee,
        matchingFields
      }
    });

    if (response?.status === 200) {
      setOpenAssignMentor(false);
      setLoaderFirstPopup(false);
      dispatch(setMessageAuto(response.data.message));
      toast.success('Auto match completed successfully');
      setMatchingFields(initialMatchingFields);
      if (response.data === 'Auto-matching completed') {
        dispatch(
          fetchMatches({
            orgId,
            groupId: grpId !== 'admin' ? grpId : coId,
            name: searchName.trim() || undefined,
            pageNumber: 1,
            pageSize: initialPageSize
          })
        );
      }
    } else {
      toast.error('Auto match could not be finished. Try again.');
      setLoaderFirstPopup(false);
    }
  };

  window.addEventListener('beforeunload', () => {
    dispatch(setMessageAuto(''));
  });

  useEffect(() => {
    dispatch(setMessageAuto(''));
  }, []);

  useEffect(() => {
    if (!orgId || !grpId) return;
    if (activeTab !== 'matches' && (searchName || '').trim()) return;
    setPageNumber(1);
    const nameParam = searchName.trim() || undefined;
    dispatch(
      fetchMatches({
        orgId,
        groupId: grpId !== 'admin' ? grpId : coId,
        name: nameParam,
        pageNumber: 1,
        pageSize: initialPageSize
      })
    );
  }, [orgId, grpId, searchName, activeTab]);

  useEffect(() => {
    if (!grpId) return;
    const t = setTimeout(() => setSearchName(searchInput.trim()), 400);
    return () => clearTimeout(t);
  }, [searchInput, grpId]);

  // Auto confirm all matches after creation is disabled per product requirement.
  // useEffect(() => {
  //   if (!allMatchesData?.matches || !Array.isArray(allMatchesData.matches)) return;
  //   if (isAutoConfirming) return;
  //
  //   const pendingMatches = allMatchesData.matches.filter((match: any) => match && !match.isConfirmed);
  //   if (!pendingMatches.length) return;
  //
  //   const normalized = pendingMatches
  //     .map((match: any) => ({
  //       id: match?.id || match?._id || _.get(match, 'data.id') || _.get(match, 'data._id')
  //     }))
  //     .filter((match: any) => Boolean(match.id));
  //
  //   if (!normalized.length) return;
  //
  //   setIsAutoConfirming(true);
  //   (async () => {
  //     try {
  //       await confirmMatchesImmediately(normalized);
  //       dispatch(fetchMatches({ orgId, groupId: grpId !== 'admin' ? grpId : coId }));
  //     } finally {
  //       setIsAutoConfirming(false);
  //     }
  //   })();
  // }, [allMatchesData?.matches, orgId, grpId, coId, dispatch, isAutoConfirming]);

  const loadedMatchesCount =
    allMatchesData?.view === 'grouped' && Array.isArray(allMatchesData.groupedMatches)
      ? allMatchesData.groupedMatches.length
      : (allMatchesData?.matches?.length ?? 0);
  const pagination = allMatchesData?.pagination;
  const hasMoreMatches = pagination
    ? loadedMatchesCount < pagination.total
    : (pageNumber === 1 && loadedMatchesCount >= initialPageSize) ||
      (pageNumber > 1 && loadedMatchesCount >= initialPageSize + (pageNumber - 1) * nextPageSize);
  const fetchNextPage = useCallback(() => {
    if (!orgId || !grpId || isFetchingMore || loading || !hasMoreMatches) return;
    const nextPage = pageNumber + 1;
    setIsFetchingMore(true);
    const nameParam = searchName.trim() || undefined;
    const groupId = grpId !== 'admin' ? grpId : coId;
    dispatch(
      fetchMatches({
        orgId,
        groupId,
        name: nameParam,
        pageNumber: nextPage,
        pageSize: nextPageSize
      })
    )
      .unwrap()
      .then(() => setPageNumber(nextPage))
      .finally(() => setIsFetchingMore(false));
  }, [orgId, grpId, coId, pageNumber, searchName, hasMoreMatches, isFetchingMore, loading]);

  useEffect(() => {
    if (activeTab !== 'matches' || !hasMoreMatches) return;
    const sentinel = loadMoreSentinelRef.current;
    const root = listContainerRef.current;
    if (!sentinel || !root) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) fetchNextPage();
      },
      { root, rootMargin: '0px 0px 30% 0px', threshold: 0 }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [activeTab, hasMoreMatches, fetchNextPage]);

  /** search (client-side fallback; server-side uses searchName) */
  const [searchValue, setSearchValue] = useState('');

  const filterData = (data: any[], searchValue: string) => {
    if (Array.isArray(data)) {
      return data.filter((item) => {
        // filter by mentee or mentor name
        return (
          item?.mentee?.displayName.toLowerCase().includes(searchValue.toLowerCase()) ||
          item?.mentor?.displayName.toLowerCase().includes(searchValue.toLowerCase())
        );
      });
    }
    return [];
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const handleOpenMenteeProfileModal = async (candidateUserId: string) => {
    if (!candidateUserId) {
      toast.error('User not found');
      return;
    }
    try {
      const groupId = grpId !== 'admin' ? grpId : coId;
      const shouldFetchMatchee = manualTriggerId && manualTriggerId !== candidateUserId;
      const [candidateRes, matcheeRes] = await Promise.all([
        API.getUserProfileInAGroup(groupId, candidateUserId),
        shouldFetchMatchee
          ? API.getUserProfileInAGroup(groupId, manualTriggerId)
          : Promise.resolve(null)
      ]);
      if (candidateRes?.status === 200) {
        setProfileModalUser(candidateRes?.data?.userDetails || candidateRes?.data?.data || {});
        setMatcheeProfileUser(
          matcheeRes?.status === 200
            ? matcheeRes?.data?.userDetails || matcheeRes?.data?.data || {}
            : null
        );
        setOpenMenteeProfileModal(true);
      } else {
        toast.error('Profile details could not be loaded. Refresh the page and try again.');
      }
    } catch (error) {
      toast.error('Profile details could not be loaded. Refresh the page and try again.');
    }
  };

  const handleCloseMenteeProfileModal = () => {
    setOpenMenteeProfileModal(false);
    setProfileModalUser(null);
    setMatcheeProfileUser(null);
  };

  const getMemberId = (member: any) =>
    member?.userId || member?.id || member?.menteeId || member?.mentorId || member?._id || member?.personal_details || '';

  const getMemberName = (member: any) => member?.displayName || member?.name || member?.fullName || 'Unnamed';

  const manualCandidates = useMemo(() => {
    const source =
      manualTriggerRole === 'Mentor'
        ? allMatchesData?.mentees
        : manualTriggerRole === 'Mentee'
        ? allMatchesData?.mentors
        : [];
    const rawList: any[] = Array.isArray(source) ? source ?? [] : [];
    return rawList
      .map((candidate) => ({
        id: getMemberId(candidate),
        displayName: getMemberName(candidate),
        headshot: candidate?.headshot,
        role:
          candidate?.role ||
          candidate?.memberRole ||
          candidate?.userRole ||
          candidate?.type ||
          (manualTriggerRole === 'Mentor' ? 'Mentee' : manualTriggerRole === 'Mentee' ? 'Mentor' : 'Member')
      }))
      .filter((candidate) => Boolean(candidate.id));
  }, [allMatchesData?.mentees, allMatchesData?.mentors, manualTriggerRole]);

  const filteredManualCandidates = useMemo(() => {
    if (!manualSearchValue.trim()) return manualCandidates;
    const query = manualSearchValue.toLowerCase();
    return manualCandidates.filter((candidate) => candidate.displayName.toLowerCase().includes(query));
  }, [manualCandidates, manualSearchValue]);

  const autoSuggestedCount = autoSuggestedMentees.length;
  const manualCount = filteredManualCandidates.length;
  const menteesToRender = manualInviteTab === 'auto' ? autoSuggestedMentees : filteredManualCandidates;
  useEffect(() => {
    setVisibleMenteesCount(manualListPageSize);
  }, [manualInviteTab, manualSearchValue, autoSuggestedMentees.length, filteredManualCandidates.length]);
  const visibleMentees = useMemo(
    () => menteesToRender.slice(0, visibleMenteesCount),
    [menteesToRender, visibleMenteesCount]
  );

  const handleManualListScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    const nearBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 120;
    if (!nearBottom) return;
    setVisibleMenteesCount((prev) => Math.min(prev + manualListPageSize, menteesToRender.length));
  };

  const handleToggleObjective = (candidateId: string, objectiveId: string) => {
    setSelectedObjectivesByCandidate((prev) => {
      const current = new Set(prev[candidateId] || []);
      if (current.has(objectiveId)) {
        current.delete(objectiveId);
      } else {
        current.add(objectiveId);
      }
      const next = { ...prev };
      if (current.size === 0) {
        delete next[candidateId];
      } else {
        next[candidateId] = Array.from(current);
      }
      return next;
    });
  };

  const handleFetchAIRecommendations = async () => {
    if (!manualTriggerId) return;
    const assigneeRole = manualTriggerRole === 'Mentor' ? 'Mentor' : 'Mentee';
    setAiLoading(true);
    setAiErrorMessage(null);
    setAiEmptyMessage(null);
    try {
      const response = await API.getAIMatchSuggestions({
        orgId,
        assigneeId: manualTriggerId,
        grpId: grpId !== 'admin' ? grpId : coId,
        assigneeRole,
        objectivesHardFilter: false,
        location: programLocation
      });
      const payload = response?.data;
      if (response?.status === 200 && payload?.data) {
        // Always show highest match % first, regardless of the AI's holistic ordering.
        const recs: any[] = [...(payload.data?.recommendations || [])].sort(
          (a: any, b: any) => (b?.aiScore ?? -1) - (a?.aiScore ?? -1)
        );
        setAiRecommendations(recs);
        setExpandedAiCards({});
        setSelectedAiCandidateIds([]);
        if (recs.length === 0) {
          setAiEmptyMessage('No suggestions from Elliott are available right now. There may be no eligible candidates left.');
        }
      } else {
        const message = payload?.message || 'Elliott could not find suggestions. Try again.';
        setAiErrorMessage(message);
        setAiRecommendations([]);
      }
    } catch (err: any) {
      const message =
        err?.response?.data?.message || err?.message || 'Elliott could not find suggestions. Try again.';
      setAiErrorMessage(message);
      setAiRecommendations([]);
    } finally {
      setAiLoading(false);
    }
  };

  const handleManualAssignMatches = async () => {
    if (!manualTriggerRole || !manualTriggerId) {
      toast.error('Select a person first');
      return;
    }
    const payload = Object.entries(selectedObjectivesByCandidate)
      .filter(([, objectives]) => objectives?.length)
      .map(([candidateId, objectiveIds]) => {
        const isTriggerMentor = manualTriggerRole === 'Mentor';
        return {
          mentorId: isTriggerMentor ? manualTriggerId : candidateId,
          menteeId: isTriggerMentor ? candidateId : manualTriggerId,
          assigneeRole: isTriggerMentor ? 'Mentee' : 'Mentor',
          objectiveIds
        };
      });

    if (!payload.length) {
      toast.error('Select at least one learning objective');
      return;
    }

    setManualAssignLoading(true);
    try {
      const response = await API.assignAMatch({
        orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: payload
      });
      if (response?.status === 200) {
        toast.success('Match(es) assigned successfully');
        dispatch(
          fetchMatches({
            orgId,
            groupId: grpId !== 'admin' ? grpId : coId,
            name: searchName.trim() || undefined,
            pageNumber: 1,
            pageSize: initialPageSize
          })
        );
        handleCloseManualInvite();
      } else {
        toast.error('The match could not be assigned. Try again.');
      }
    } catch (error) {
      toast.error('The match could not be assigned. Try again.');
    } finally {
      setManualAssignLoading(false);
    }
  };

  const toggleAiCandidate = (candidateId: string) => {
    setSelectedAiCandidateIds((prev) =>
      prev.includes(candidateId)
        ? prev.filter((existing) => existing !== candidateId)
        : [...prev, candidateId]
    );
  };

  // Assign the AI recommendations the admin checked. The match is created UNCONFIRMED
  // (no auto-confirm) so it appears on Matches awaiting confirmation, and each match
  // carries its AI reasoning so it can be reviewed later from the 3-dots menu.
  const handleAssignAiMatches = async () => {
    if (!manualTriggerRole || !manualTriggerId) {
      toast.error('Select a person first');
      return;
    }
    const isTriggerMentor = manualTriggerRole === 'Mentor';
    const payload = aiRecommendations
      .map((rec: any) => {
        const candidateId = manualTriggerRole === 'Mentee' ? rec.mentorId : rec.menteeId;
        if (!candidateId || !selectedAiCandidateIds.includes(candidateId)) return null;
        return {
          mentorId: isTriggerMentor ? manualTriggerId : candidateId,
          menteeId: isTriggerMentor ? candidateId : manualTriggerId,
          assigneeRole: isTriggerMentor ? 'Mentee' : 'Mentor',
          aiScore: typeof rec.aiScore === 'number' ? rec.aiScore : undefined,
          aiOverallAssessment: rec.aiOverallAssessment,
          aiFieldComparisons: Array.isArray(rec.aiFieldComparisons) ? rec.aiFieldComparisons : []
        };
      })
      .filter(Boolean);

    if (!payload.length) {
      toast.error('Select at least one match');
      return;
    }

    setManualAssignLoading(true);
    try {
      const response = await API.assignAMatch({
        orgId,
        grpId: grpId !== 'admin' ? grpId : coId,
        data: payload
      });
      if (response?.status === 200) {
        toast.success('Match(es) assigned successfully');
        dispatch(
          fetchMatches({
            orgId,
            groupId: grpId !== 'admin' ? grpId : coId,
            name: searchName.trim() || undefined,
            pageNumber: 1,
            pageSize: initialPageSize
          })
        );
        handleCloseManualInvite();
      } else {
        toast.error('The match could not be assigned. Try again.');
      }
    } catch (error) {
      toast.error('The match could not be assigned. Try again.');
    } finally {
      setManualAssignLoading(false);
    }
  };

  const handleOpenMatchReasoning = () => {
    setAnchorElConfirm(null);
    setOpenMatchReasoning(true);
  };

  const handleCloseMatchReasoning = () => {
    setOpenMatchReasoning(false);
  };

  const isGroupedView = allMatchesData?.view === 'grouped';
  const rawGroupedMatches = allMatchesData?.groupedMatches;
  const groupedListForMemo: GroupedMatchItem[] = isGroupedView
    ? (Array.isArray(rawGroupedMatches) ? (rawGroupedMatches as GroupedMatchItem[]) : [])
    : [];
  const groupedUserIds = useMemo(() => new Set(groupedListForMemo.map((i) => i.userId)), [groupedListForMemo]);
  const menteesFromData: any[] = Array.isArray(allMatchesData?.mentees) ? (allMatchesData?.mentees ?? []) : [];
  const mentorsFromData: any[] = Array.isArray(allMatchesData?.mentors) ? (allMatchesData?.mentors ?? []) : [];
  const toGroupedItem = useCallback((m: any, role: 'mentee' | 'mentor'): GroupedMatchItem => ({
    userId: m?.id ?? m?.userId ?? (role === 'mentee' ? m?.menteeId : m?.mentorId) ?? m?._id ?? '',
    mid: m?.mid,
    displayName: m?.displayName ?? m?.name ?? 'Unnamed',
    headshot: m?.headshot,
    bio: m?.bio,
    matches: [],
    roles: [role]
  }), []);
  /** Mentees + mentors que não estão na lista de matches (exibida desde a primeira request, entre página 1 e página 2+ das matches) */
  const combinedMembersAfterGrouped = useMemo(() => {
    if (!isGroupedView) return [];
    const me = menteesFromData.filter((m) => { const id = m?.id ?? m?.userId ?? m?.menteeId ?? m?._id; return id && !groupedUserIds.has(id); }).map((m) => toGroupedItem(m, 'mentee'));
    const mo = mentorsFromData.filter((m) => { const id = m?.id ?? m?.userId ?? m?.mentorId ?? m?._id; return id && !groupedUserIds.has(id); }).map((m) => toGroupedItem(m, 'mentor'));
    return [...me, ...mo].sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '', undefined, { sensitivity: 'base' }));
  }, [isGroupedView, menteesFromData, mentorsFromData, groupedUserIds, toGroupedItem]);

  const unmatchedMentors = useMemo(() => {
    const list = mentorsFromData.filter((m) => {
      const id = m?.id ?? m?.userId ?? m?.mentorId ?? m?._id;
      return id && !groupedUserIds.has(id);
    });
    return [...list].sort((a, b) =>
      (a?.displayName ?? a?.name ?? '').localeCompare(b?.displayName ?? b?.name ?? '', undefined, { sensitivity: 'base' })
    );
  }, [mentorsFromData, groupedUserIds]);
  const unmatchedMentees = useMemo(() => {
    const list = menteesFromData.filter((m) => {
      const id = m?.id ?? m?.userId ?? m?.menteeId ?? m?._id;
      return id && !groupedUserIds.has(id);
    });
    return [...list].sort((a, b) =>
      (a?.displayName ?? a?.name ?? '').localeCompare(b?.displayName ?? b?.name ?? '', undefined, { sensitivity: 'base' })
    );
  }, [menteesFromData, groupedUserIds]);
  const searchInputLower = (searchInput || '').trim().toLowerCase();
  const filteredUnmatchedMentors = useMemo(() => {
    if (!searchInputLower) return unmatchedMentors;
    return unmatchedMentors.filter((m) =>
      (m?.displayName ?? m?.name ?? '').toLowerCase().includes(searchInputLower)
    );
  }, [unmatchedMentors, searchInputLower]);
  const filteredUnmatchedMentees = useMemo(() => {
    if (!searchInputLower) return unmatchedMentees;
    return unmatchedMentees.filter((m) =>
      (m?.displayName ?? m?.name ?? '').toLowerCase().includes(searchInputLower)
    );
  }, [unmatchedMentees, searchInputLower]);

  const searchLower = (searchName || '').trim().toLowerCase();
  const localSearchFallbackList = useMemo(() => {
    if (!searchLower) return [];
    const pool = combinedMembersAfterGrouped.length ? combinedMembersAfterGrouped : [...menteesFromData.filter((m) => { const id = m?.id ?? m?.userId ?? m?.menteeId ?? m?._id; return id && !groupedUserIds.has(id); }).map((m) => toGroupedItem(m, 'mentee')), ...mentorsFromData.filter((m) => { const id = m?.id ?? m?.userId ?? m?.mentorId ?? m?._id; return id && !groupedUserIds.has(id); }).map((m) => toGroupedItem(m, 'mentor'))].sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '', undefined, { sensitivity: 'base' }));
    return pool.filter((item) => (item.displayName || '').toLowerCase().includes(searchLower));
  }, [searchLower, combinedMembersAfterGrouped, menteesFromData, mentorsFromData, groupedUserIds, toGroupedItem]);

  const memberCount =
    allMatchesData?.view === 'grouped'
      ? (allMatchesData.pagination?.total ?? (Array.isArray(allMatchesData?.groupedMatches) ? allMatchesData.groupedMatches.length : 0))
      : (allMatchesData?.matches && Array.isArray(allMatchesData.matches) ? allMatchesData.matches.length : 0) +
        (allMatchesData?.mentees && Array.isArray(allMatchesData.mentees) ? allMatchesData.mentees.length : 0) +
        (allMatchesData?.mentors && Array.isArray(allMatchesData.mentors) ? allMatchesData.mentors.length : 0);

  const getMatchesList = () => {
    if (!allMatchesData) {
      return (
        <Box
          sx={{
            width: '100%',
            py: 6,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#B6B6B6',
            fontSize: 16,
            fontWeight: 500
          }}
        >
          No matches available yet.
        </Box>
      );
    }

    const isGroupedView = allMatchesData.view === 'grouped';
    const rawGrouped = allMatchesData.groupedMatches;
    const groupedList: GroupedMatchItem[] = isGroupedView ? (Array.isArray(rawGrouped) ? (rawGrouped as GroupedMatchItem[]) : []) : [];

    const showLocalSearchResults = searchLower && groupedList.length === 0 && localSearchFallbackList.length > 0;
    /** Matches tab: only paginated grouped list (no merge with unmatched). Mentors/Mentees tabs render their own lists. */
    const firstPageMatches = groupedList.slice(0, initialPageSize);
    const restMatches = groupedList.slice(initialPageSize);
    const orderedList: GroupedMatchItem[] =
      activeTab === 'matches'
        ? (showLocalSearchResults ? localSearchFallbackList : [...firstPageMatches, ...restMatches])
        : showLocalSearchResults
          ? localSearchFallbackList
          : searchLower && groupedList.length > 0
            ? groupedList
            : [...firstPageMatches, ...combinedMembersAfterGrouped, ...restMatches];

    if (isGroupedView && groupedList.length >= 0) {
      const getStatusInfo = (match: any) => {
        const label =
          match?.matchStatus === 'Inactive'
            ? 'Ended'
            : match?.isConfirmed
            ? 'Ongoing'
            : 'Pending';
        const color = label === 'Ongoing' ? '#F79420' : label === 'Ended' ? '#868686' : '#FFB800';
        return { statusLabel: label, statusColor: color };
      };

      if (orderedList.length === 0) {
        return (
          <Box
            sx={{
              width: '100%',
              py: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#B6B6B6',
              fontSize: 16,
              fontWeight: 500
            }}
          >
            {searchName.trim() ? 'No matches found for this search.' : 'No matches have been created yet.'}
          </Box>
        );
      }

      return (
        <Box display="flex" flexDirection="column" gap={1.5} pb={2}>
          {orderedList.map((item) => {
            const stats = (item.stats ?? {}) as { pastMeetings?: number; futureMeetings?: number; lastConnection?: number };
            const totalPast = stats.pastMeetings ?? 0;
            const totalFuture = stats.futureMeetings ?? 0;
            const lastConnection = stats.lastConnection;
            const matchCountLabel = `${item.matches?.length ?? 0} match${(item.matches?.length ?? 0) === 1 ? '' : 'es'}`;
            const isExpanded = expandedRows[item.userId] ?? true;

            const memberForAssign = {
              id: item.userId,
              role: (item.roles?.[0] === 'mentee' ? 'Mentee' : 'Mentor') as MemberRole,
              displayName: item.displayName,
              headshot: item.headshot,
              bio: item.bio,
              matches: []
            };

            return (
              <Accordion
                key={item.userId}
                disableGutters
                expanded={isExpanded}
                onChange={(_, expanded) =>
                  setExpandedRows((prev) => ({ ...prev, [item.userId]: expanded }))
                }
                sx={{
                  background: '#0F0F0F',
                  color: '#FDFDFD'
                }}
              >
                <AccordionSummary
                  sx={{
                    px: 3.4,
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: '1px solid #444444',
                    minHeight: 'unset',
                    '.MuiAccordionSummary-expandIconWrapper': {
                      order: -1,
                      marginRight: 0,
                      width: 24,
                      display: 'flex',
                      justifyContent: 'center'
                    }
                  }}
                  expandIcon={<ExpandMoreIcon sx={{ color: '#FDFDFD', fontSize: 20 }} />}
                >
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: matchGridTemplate,
                      alignItems: 'center',
                      width: '100%',
                      gap: 1.5
                    }}
                  >
                    <Box sx={{ width: 0 }} />
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', textAlign: 'left', marginLeft: '-20px' }}>
                      <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600, mr: 1 }}>
                        {item.displayName}
                      </Typography>
                      <Button
                        variant="text"
                        onClick={() => handleOpenAssignForMember(memberForAssign)}
                        sx={{
                          color: '#F79420',
                          fontWeight: 600,
                          fontSize: 10,
                          textTransform: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          borderRadius: '6px',
                          padding: 0
                        }}
                      >
                        Assign Match
                      </Button>
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails sx={{ px: 2.5, py: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {(item.matches?.length ?? 0) === 0 ? (
                    <Box
                      sx={{
                        px: 0.5,
                        py: 1,
                        color: '#868686',
                        fontSize: 13
                      }}
                    >
                      No matches yet. Click “Assign Match” to add one.
                    </Box>
                  ) : (
                    (item.matches ?? []).map((match, idx) => {
                      const { statusLabel, statusColor } = getStatusInfo(match);
                      const matchId = match.id || match.matchId;
                      const fallbackKey = matchId || `${item.userId}-match-${idx}`;
                      const lastConnectionText = match.lastConnection
                        ? unixToHumanReadable(match.lastConnection)
                        : 'Not yet';
                      const counterpart = match.user ?? {};

                      return (
                        <Box
                          key={fallbackKey}
                          sx={{
                            px: 1.5,
                            display: 'grid',
                            gridTemplateColumns: matchGridTemplate,
                            background: '#0F0F0F'
                          }}
                        >
                          <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600 }}>{}</Typography>
                          <Box>
                            <Typography sx={{ color: '#868686', fontSize: 14, fontWeight: 600 }} noWrap>
                              {counterpart?.displayName || 'Unnamed'}
                            </Typography>
                          </Box>
                          <Typography sx={{ color: '#F79420', fontSize: 14 }} noWrap>
                            {item.displayName}
                          </Typography>
                          <Typography sx={{ color: statusColor, fontSize: 14, fontWeight: 600 }} noWrap>
                            {statusLabel}
                          </Typography>
                          <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                            {match.pastMeetings ?? 0}
                          </Typography>
                          <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                            {match.futureMeetings ?? 0}
                          </Typography>
                          <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'right' }}>
                            {lastConnectionText}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                            <IconButton
                              disabled={!matchId}
                              onClick={(event) => matchId && handleOpenMatchPopover(matchId, event)}
                            >
                              <MoreVertIcon sx={{ color: '#FDFDFD' }} />
                            </IconButton>
                            {match?.isConfirmed === false && (
                              <DosenButton
                                sizeVariant="sm"
                                tone="cta"
                                onClick={() => matchId && handleConfirmMatch(matchId)}
                                sx={{ minWidth: 110, px: 2, py: 0.5 }}
                              >
                                Confirm Match
                              </DosenButton>
                            )}
                          </Box>
                        </Box>
                      );
                    })
                  )}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      );
    }

    const storedMatches: any[] = Array.isArray(allMatchesData.matches) ? (allMatchesData.matches as any[]) : [];
    const rawMatchesList: any[] = [...storedMatches, ...dataArray];
    const matchKey = (match: any) =>
      match?.id || match?._id || _.get(match, 'data.id') || _.get(match, 'data._id') || _.get(match, 'match.id');
    const uniqueMatchesMap = new Map<string, any>();
    rawMatchesList.forEach((match, index) => {
      const key = matchKey(match) || `match-${index}`;
      if (!uniqueMatchesMap.has(key)) {
        uniqueMatchesMap.set(key, match);
      }
    });
    const matchesList: any[] = Array.from(uniqueMatchesMap.values());
    const mentorsList: any[] = Array.isArray(allMatchesData.mentors) ? (allMatchesData.mentors as any[]) : [];
    const menteesList: any[] = Array.isArray(allMatchesData.mentees) ? (allMatchesData.mentees as any[]) : [];

    const memberMap: Record<string, MemberEntry> = {};

    const ensureMember = (member: any, role: MemberRole): MemberEntry | null => {
      const id =
        member?.userId || member?.id || member?.mentorId || member?.menteeId || member?.personal_details || '';
      if (!id) {
        return null;
      }
      if (!memberMap[id]) {
        memberMap[id] = {
          id,
          role,
          displayName: member.displayName || member?.name || 'Unnamed',
          headshot: member?.headshot,
          bio: member?.bio,
          matches: []
        };
      }
      return memberMap[id];
    };

    const getStatusInfo = (match: any) => {
      const label =
        match?.matchStatus === 'Inactive'
          ? 'Ended'
          : match?.isConfirmed
          ? 'Ongoing'
          : 'Pending';
      const color = label === 'Ongoing' ? '#F79420' : label === 'Ended' ? '#868686' : '#FFB800';
      return { statusLabel: label, statusColor: color };
    };

    const getObjectivesLabel = (match: any) => {
      const objectivesCount =
        _.get(match, 'data.objectives.length') || match?.objectives?.length || 0;
      return objectivesCount ? `${objectivesCount} objectives` : 'No objectives';
    };

    matchesList.forEach((match) => {
      const mentor = match?.mentor ?? {};
      const mentee = match?.mentee ?? {};
      const { statusLabel, statusColor } = getStatusInfo(match);
      const objectivesLabel = getObjectivesLabel(match);
      const mentorEntry = ensureMember(mentor, 'Mentor');
      const menteeEntry = ensureMember(mentee, 'Mentee');

      if (mentorEntry) {
        mentorEntry.matches.push({
          match,
          counterpart: mentee,
          counterpartRole: 'Mentee',
          statusLabel,
          statusColor,
          objectivesLabel
        });
      }
      if (menteeEntry) {
        menteeEntry.matches.push({
          match,
          counterpart: mentor,
          counterpartRole: 'Mentor',
          statusLabel,
          statusColor,
          objectivesLabel
        });
      }
    });

    // Com busca por nome: só mostramos accordeons para pessoas que aparecem nos matches retornados.
    // Sem busca: incluímos todos mentores/mentees das listas (comportamento original).
    if (!searchName.trim()) {
      mentorsList.forEach((mentor) => ensureMember(mentor, 'Mentor'));
      menteesList.forEach((mentee) => ensureMember(mentee, 'Mentee'));
    }

    const memberEntries = Object.values(memberMap).sort((a, b) => {
      if (a.role !== b.role) {
        return a.role === 'Mentor' ? -1 : 1;
      }
      return a.displayName.localeCompare(b.displayName);
    });

    if (!memberEntries.length) {
      return (
        <Box
          sx={{
            width: '100%',
            py: 6,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#B6B6B6',
            fontSize: 16,
            fontWeight: 500
          }}
        >
          {searchName.trim() ? 'No matches found for this search.' : 'No matches have been created yet.'}
        </Box>
      );
    }

    return (
      <Box display="flex" flexDirection="column" gap={1.5} pb={2}>
        {memberEntries.map((member) => {
          const totalPastCalls = member.matches.reduce(
            (sum, entry) => sum + (entry.match?.pastCalls ?? 0),
            0
          );
          const totalFutureCalls = member.matches.reduce(
            (sum, entry) => sum + (entry.match?.futureCalls ?? 0),
            0
          );
          const connections = member.matches
            .map((entry) => entry.match?.lastConnection)
            .filter(Boolean)
            .sort((a, b) => (b || 0) - (a || 0));
          const lastConnection = connections[0];
          const summaryMatch =
            member.matches.find((entry) => entry.statusLabel === 'Ongoing') || member.matches[0];
          const summaryStatusLabel = summaryMatch?.statusLabel || (member.matches.length ? 'Pending' : 'No matches');
          const summaryStatusColor = summaryMatch?.statusColor || '#868686';
          const summaryObjectives = summaryMatch?.objectivesLabel || 'No objectives';
          const matchCountLabel = `${member.matches.length} match${member.matches.length === 1 ? '' : 'es'}`;

          const isExpanded = expandedRows[member.id] ?? true;

          return (
            <Accordion
              key={member.id}
              disableGutters
              expanded={isExpanded}
              onChange={(_, expanded) =>
                setExpandedRows((prev) => ({ ...prev, [member.id]: expanded }))
              }
              sx={{
                background: '#0F0F0F',
                color: '#FDFDFD'
              }}
            >
              <AccordionSummary
                sx={{
                  px: 3.4,
                  // py: 1.25,
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid #444444',
                  minHeight: 'unset',
                  '.MuiAccordionSummary-expandIconWrapper': {
                    order: -1,
                    marginRight: 0,
                    width: 24,
                    display: 'flex',
                    justifyContent: 'center'
                  }
                }}
                expandIcon={<ExpandMoreIcon sx={{ color: '#FDFDFD', fontSize: 20 }} />}
              >
                {/* <ExpandMoreIcon sx={{ color: '#FDFDFD', fontSize: 20 }} /> */}
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: matchGridTemplate,
                    alignItems: 'center',
                    width: '100%',
                    gap: 1.5
                  }}
                >
                  <Box sx={{ width: 0 }} />
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', textAlign: 'left', marginLeft: '-20px' }}>
                    <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600, mr: 1 }}>
                      {member.displayName}
                    </Typography>
                    <Button
                      variant="text"
                      onClick={() => handleOpenAssignForMember(member)}
                      sx={{
                        color: '#F79420',
                        fontWeight: 600,
                        fontSize: 10,
                        textTransform: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        // gap: 0.75,
                        borderRadius: '6px',
                        padding: 0
                      }}
                    >
                      Assign Match
                    </Button>
                    
                    {/* <Typography sx={{ color: '#868686', fontSize: 12, fontWeight: 500 }} noWrap>
                      {member.role}
                    </Typography> */}
                  </Box>
                    
                 
                  {/* <Typography sx={{ color: summaryStatusColor, fontSize: 14, fontWeight: 600 }} noWrap>
                    {summaryStatusLabel}
                  </Typography> */}
                  {/* <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'center' }} noWrap>
                    {summaryObjectives}
                  </Typography> */}
                  {/* <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'center' }}>
                    {totalPastCalls}
                  </Typography>
                  <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'center' }}>
                    {totalFutureCalls}
                  </Typography>
                  <Typography sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 400, textAlign: 'right' }}>
                    {lastConnection ? unixToHumanReadable(lastConnection) : '—'}
                  </Typography>
                   */}
                </Box>
              </AccordionSummary>

              <AccordionDetails sx={{ px: 2.5, py: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {member.matches.length === 0 ? (
                  <Box
                    sx={{
                      px: 0.5,
                      py: 1,
                      color: '#868686',
                      fontSize: 13
                    }}
                  >
                    No matches yet. Click “Assign Match” to add one.
                  </Box>
                ) : (
                  member.matches.map((entry, idx) => {
                    const { match, counterpart, counterpartRole, statusLabel, statusColor, objectivesLabel } = entry;
                    const matchId =
                      match?.id ||
                      match?._id ||
                      _.get(match, 'data.id') ||
                      _.get(match, 'data._id') ||
                      _.get(match, 'match.id');
                    const fallbackKey = matchId || `${member.id}-match-${idx}`;
                    const lastConnectionText = match?.lastConnection
                      ? unixToHumanReadable(match.lastConnection)
                      : 'Not yet';

                    return (
                      <Box
                        key={fallbackKey}
                        sx={{
                          px: 1.5,
                          display: 'grid',
                          gridTemplateColumns: matchGridTemplate,
                          // alignItems: 'center',
                          gap: 1.5,
                          // borderRadius: '6px',
                          // border: '1px solid #2A2A2A',
                          background: '#0F0F0F'
                        }}
                      >
                        <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600 }}>{}</Typography>
                        <Box>
                          <Typography sx={{ color: '#868686', fontSize: 14, fontWeight: 600 }} noWrap>
                            {counterpart?.displayName || 'Unnamed'}
                          </Typography>
                          {/* <RoleTypeTag category={counterpartRole} /> */}
                        </Box>
                        <Typography sx={{ color: '#F79420', fontSize: 14 }} noWrap>
                          {/* {matchId ? matchId.slice(0, 6) : 'Match'} */}
                           {member.displayName}
                        </Typography>
                        <Typography sx={{ color: statusColor, fontSize: 14, fontWeight: 600 }} noWrap>
                          {statusLabel}
                        </Typography>
                        {/* <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                          {objectivesLabel}
                        </Typography> */}
                        <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                          {match?.pastCalls ?? 0}
                        </Typography>
                        <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'center' }}>
                          {match?.futureCalls ?? 0}
                        </Typography>
                        <Typography sx={{ color: '#FDFDFD', fontSize: 12, textAlign: 'right' }}>
                          {lastConnectionText}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                          <IconButton
                            disabled={!matchId}
                            onClick={(event) => matchId && handleOpenMatchPopover(matchId, event)}
                          >
                            <MoreVertIcon sx={{ color: '#FDFDFD' }} />
                          </IconButton>
                          {match?.isConfirmed === false && (
                            <DosenButton
                              sizeVariant="sm"
                              tone="cta"
                              onClick={() => matchId && handleConfirmMatch(matchId)}
                              sx={{ minWidth: 110, px: 2, py: 0.5 }}
                            >
                              Confirm Match
                            </DosenButton>
                          )}
                        </Box>
                      </Box>
                    );
                  })
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    );
  };

  const member = memberList;
  const hasAnyTrueValue = Object.values(matchingFields).some((value) => value === true);

  const [page, setPage] = useState(1);
  const itemsPerPage = 25;
  const totalItems = 10 * itemsPerPage; // 10 pages * 25 items per page
  const totalPages = 10; // Total number of pages

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const [exportLoading, setExportLoading] = useState(false);

  const handleExportMatches = async () => {
    setExportLoading(true);
    try {
      const response = await API.exportMatches({
        grpId: grpId,
        orgId: orgId
      });

      if (response.data?.message === 'Exported successfully') {
        toast.success('Your report will be emailed to you shortly');
      } else {
        toast.error('The matches could not be exported. Try again.');
      }
    } catch (error) {
      toast.error('The matches could not be exported. Try again.');
    } finally {
      setExportLoading(false);
    }
  };

  /** Export Button Popover */
  // const handleClickExport = (event: any) => {
  //   setAnchorExport(event.currentTarget);
  //   setIsClicked(true);
  // };

  // const handleCloseExport = () => {
  //   setAnchorExport(null);
  //   setIsClicked(false);
  // };

  // const handleClickDownloadPdf = (event: any) => { };

  // const handleClickExportExcel = (event: any) => { };

  // const handleClickExportPlan = (event: any) => { };

  // const openExport = Boolean(anchorExport);

  return (
    <>
        <Box
          className={classs.mainBody}
          sx={{
            bgcolor: '#0F0F0F !important',
            color: '#FDFDFD !important',
            display: 'flex',
            flexDirection: 'column',
            height: '100% !important',
            minHeight: '100%',
            overflow: 'hidden'
          }}
        >
          <Box display="flex" flexDirection="column" flex={1} minHeight={0} sx={{ height: '100%' }}>
            <Box flex="1 1 auto" minWidth={0} minHeight={0} display="flex" flexDirection="column" sx={{ height: '100%' }}>
              <TableContainer
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 0,
                  height: '100%',
                  backgroundColor: '#0F0F0F !important',
                  color: '#FDFDFD !important'
                }}
              >
                <Box
                  px={3}
                  py={2.5}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid #1C1C1C"
                  flexShrink={0}
                >
                  <Box display="flex" alignItems="center" gap={2}>
                    <Typography sx={{ color: '#B6B6B6', fontSize: 16, fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
                      {activeTab === 'mentors'
                        ? (filteredUnmatchedMentors?.length ?? 0)
                        : activeTab === 'mentees'
                        ? (filteredUnmatchedMentees?.length ?? 0)
                        : memberCount || 0}{' '}
                      {activeTab === 'mentors'
                        ? w('mentor', { count: filteredUnmatchedMentors?.length ?? 0 })
                        : activeTab === 'mentees'
                        ? w('mentee', { count: filteredUnmatchedMentees?.length ?? 0 })
                        : 'Member' + (memberCount === 1 ? '' : 's')}
                    </Typography>
                    <TextField
                      size="small"
                      placeholder="Search people..."
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      sx={{
                        width: 220,
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#1C1C1C',
                          borderRadius: '6px',
                          fontSize: 13,
                          color: '#FDFDFD',
                          '& fieldset': { borderColor: '#2A2A2A' },
                          '&:hover fieldset': { borderColor: '#404040' },
                          '&.Mui-focused fieldset': { borderColor: '#565656' }
                        },
                        '& .MuiInputBase-input::placeholder': { color: '#868686', opacity: 1 }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" sx={{ color: '#868686', mr: 0 }}>
                            <SearchIcon sx={{ fontSize: 20 }} />
                          </InputAdornment>
                        )
                      }}
                    />
                    <Box
                      sx={{
                        display: 'inline-flex',
                        borderRadius: 1,
                        overflow: 'hidden',
                        border: '1px solid #2A2A2A'
                      }}
                    >
                      {(['mentors', 'mentees', 'matches'] as const).map((tab) => {
                        const isSel = activeTab === tab;
                        const label =
                          tab === 'mentors'
                            ? `Unmatched ${w('mentor', { plural: true })}`
                            : tab === 'mentees'
                            ? `Unmatched ${w('mentee', { plural: true })}`
                            : 'Created Matches';
                        return (
                          <Box
                            key={tab}
                            role="button"
                            onClick={() => setActiveTab(tab)}
                            sx={{
                              px: 2.25,
                              py: 1.1,
                              bgcolor: isSel ? '#444444' : '#2A2A2A',
                              color: isSel ? '#FDFDFD' : '#B6B6B6',
                              fontSize: 12,
                              fontWeight: isSel ? 700 : 400,
                              fontFamily: 'Inter, sans-serif',
                              cursor: 'pointer'
                            }}
                          >
                            {label}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    {onOpenSettings && (
                      <Button
                        onClick={onOpenSettings}
                        sx={{
                          px: 2,
                          py: 1.25,
                          background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                          borderRadius: '6px',
                          color: '#FDFDFD',
                          fontSize: 13,
                          fontWeight: 700,
                          textTransform: 'none',
                          minWidth: 110,
                          '&:hover': { opacity: 0.9 }
                        }}
                      >
                        Settings
                      </Button>
                    )}
                    <Button
                      onClick={handleExportMatches}
                      disabled={exportLoading}
                      sx={{
                        px: 1.75,
                        py: 1.25,
                        background: '#1C1C1C',
                        borderRadius: '6px',
                        color: '#FDFDFD',
                        border: '1px solid #1C1C1C',
                        fontSize: 13,
                        fontWeight: 500,
                        textTransform: 'none',
                        minWidth: 120,
                        '&:hover': { background: '#2A2A2A' },
                        '&.Mui-disabled': { background: 'rgba(0, 0, 0, 0.2)', color: '#565656', borderColor: '#2A2A2A' }
                      }}
                    >
                      {exportLoading ? 'Exporting...' : 'Export Data'}
                    </Button>
                  </Box>
                </Box>
                <Divider sx={{ opacity: 0.1, border: '.5px' }} />
                  <Box ref={listContainerRef} sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 2, py: 2 }}>
                    {loading && !isFetchingMore && !allMatchesData ? (
                      <Box aria-busy aria-label="Loading" sx={{ display: 'flex', flexDirection: 'column', gap: 1, py: 1 }}>
                        {Array.from({ length: 6 }, (_, i) => (
                          <Bone key={i} height={52} />
                        ))}
                      </Box>
                    ) : activeTab === 'mentors' ? (
                      <Box display="flex" flexDirection="column" gap={0}>
                        {(filteredUnmatchedMentors?.length ?? 0) === 0 ? (
                          <Typography textAlign="center" sx={{ color: '#B6B6B6', fontSize: 16, fontWeight: 500, py: 6 }}>
                            {searchInput.trim()
                              ? `No ${w('mentor', { plural: true, lower: true })} match your search.`
                              : `No unmatched ${w('mentor', { plural: true, lower: true })}.`}
                          </Typography>
                        ) : (
                          filteredUnmatchedMentors.map((m) => {
                            const id = getMemberId(m);
                            const name = m?.displayName ?? m?.name ?? 'Unnamed';
                            const memberForAssign: MemberEntry = {
                              id,
                              role: 'Mentor',
                              displayName: name,
                              headshot: m?.headshot,
                              bio: m?.bio,
                              matches: []
                            };
                            return (
                              <Box
                                key={id}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                  py: 1.5,
                                  px: 1,
                                  borderBottom: '1px solid #2A2A2A'
                                }}
                              >
                                <ChatAvatarComponent
                                  image={m?.headshot}
                                  firstLetter={name?.slice(0, 1)}
                                  width="40px"
                                  height="40px"
                                  type="noStatus"
                                />
                                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600 }}>
                                  {name}
                                </Typography>
                                <Button
                                  variant="text"
                                  onClick={() => handleOpenAssignForMember(memberForAssign)}
                                  sx={{
                                    color: '#F79420',
                                    fontWeight: 600,
                                    fontSize: 10,
                                    textTransform: 'none',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    borderRadius: '6px',
                                    padding: 0,
                                    ml: 'auto'
                                  }}
                                >
                                  Assign Match
                                </Button>
                              </Box>
                            );
                          })
                        )}
                      </Box>
                    ) : activeTab === 'mentees' ? (
                      <Box display="flex" flexDirection="column" gap={0}>
                        {(filteredUnmatchedMentees?.length ?? 0) === 0 ? (
                          <Typography textAlign="center" sx={{ color: '#B6B6B6', fontSize: 16, fontWeight: 500, py: 6 }}>
                            {searchInput.trim()
                              ? `No ${w('mentee', { plural: true, lower: true })} match your search.`
                              : `No unmatched ${w('mentee', { plural: true, lower: true })}.`}
                          </Typography>
                        ) : (
                          filteredUnmatchedMentees.map((m) => {
                            const id = getMemberId(m);
                            const name = m?.displayName ?? m?.name ?? 'Unnamed';
                            const memberForAssign: MemberEntry = {
                              id,
                              role: 'Mentee',
                              displayName: name,
                              headshot: m?.headshot,
                              bio: m?.bio,
                              matches: []
                            };
                            return (
                              <Box
                                key={id}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                  py: 1.5,
                                  px: 1,
                                  borderBottom: '1px solid #2A2A2A'
                                }}
                              >
                                <ChatAvatarComponent
                                  image={m?.headshot}
                                  firstLetter={name?.slice(0, 1)}
                                  width="40px"
                                  height="40px"
                                  type="noStatus"
                                />
                                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 600 }}>
                                  {name}
                                </Typography>
                                <Button
                                  variant="text"
                                  onClick={() => handleOpenAssignForMember(memberForAssign)}
                                  sx={{
                                    color: '#F79420',
                                    fontWeight: 600,
                                    fontSize: 10,
                                    textTransform: 'none',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    borderRadius: '6px',
                                    padding: 0,
                                    ml: 'auto'
                                  }}
                                >
                                  Assign Match
                                </Button>
                              </Box>
                            );
                          })
                        )}
                      </Box>
                    ) : (
                      <>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: matchGridTemplate,
                    alignItems: 'center',
                    color: '#868686',
                    fontSize: 12,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    columnGap: 6,
                    width: '100%'
                  }}
                >
                  <Box />
                  <Box sx={{ textAlign: 'left' }}>Name</Box>
                  <Box sx={{ textAlign: 'left' }}>Matches</Box>
                  <Box sx={{ textAlign: 'left' }}>Status</Box>
                  <Box sx={{ textAlign: 'left' }}>Past Meetings</Box>
                  <Box sx={{ textAlign: 'left' }}>Future Meetings</Box>
                  <Box sx={{ textAlign: 'left' }}>Last Connection</Box>
                  <Box />
                </Box>
                        {allMatchesData &&
                        ((allMatchesData.view === 'grouped') ||
                        !(typeof allMatchesData.matches === 'string' &&
                          typeof allMatchesData.mentees === 'string' &&
                          typeof allMatchesData.mentors === 'string')) ? (
                          <>
                            {getMatchesList()}
                            {hasMoreMatches && (
                              <Box
                                ref={loadMoreSentinelRef}
                                sx={{ minHeight: 48, py: 2, borderBottom: '1px solid #2A2A2A' }}
                              />
                            )}
                            {isFetchingMore && (
                              <Box
                                sx={{
                                  py: 1.5,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  bgcolor: '#0F0F0F',
                                  flexShrink: 0
                                }}
                              >
                                <Bone height={52} />
                              </Box>
                            )}
                          </>
                        ) : allMatchesData ? (
                          <Typography textAlign="center" sx={{ color: '#FDFDFD', py: 4 }}>
                            {mentorsFromData.length === 0 || menteesFromData.length === 0
                              ? 'No people are available to match yet'
                              : 'No matches have been created yet'}
                          </Typography>
                        ) : null}
                      </>
                    )}
                  </Box>
                </TableContainer>
            </Box>
          </Box>
          <Popover
            id={idConfirm}
            open={openConfirm}
            anchorEl={anchorElConfirm}
            onClose={handleCloseConfirmPopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            {matchSingle?.matchStatus === 'Inactive' && (
              <Box className="PopoverListStyle">
                <ProfilePersonIcon />
                <Typography color="primary">Ended</Typography>
              </Box>
            )}
            {matchSingle?.isConfirmed && matchSingle?.matchStatus === 'Active' && (
              <Box className="PopoverListStyle" onClick={handleOpendelete}>
                <ProfilePersonIcon />
                <Typography color="primary">Remove Match</Typography>
              </Box>
            )}
            {/* Confirm Match option removed from menu per product requirement */}
            <Box className="PopoverListStyle" onClick={handleOpenMatchDetails}>
              <PreviewIcon />
              <Typography color="primary">View Match Details</Typography>
            </Box>
            {(matchSingle?.aiOverallAssessment ||
              (Array.isArray(matchSingle?.aiFieldComparisons) &&
                matchSingle.aiFieldComparisons.length > 0)) && (
              <Box className="PopoverListStyle" onClick={handleOpenMatchReasoning}>
                <InfoOutlinedIcon sx={{ color: '#F79420', fontSize: 18 }} />
                <Typography color="primary">Match Reasoning</Typography>
              </Box>
            )}
          </Popover>
            {openProfile && activeUserDetails && (
              <Box width="350px" flex="0 0 350px" height="100%">
                <ChatProfile
                  workHistory={copiedUserDetails?.workHistory}
                  educationDetails={copiedUserDetails?.education}
                  chatProfile={copiedUserDetails}
                  onCloseChatProfile={() => {
                    setOpenProfile(false);
                  }}
                  parentComponent="sideSmallProfile"
                  // loading={true}
                />
              </Box>
            )}
          </Box>

          {/* Assign a mentor first Popup */}
          <AssignMatchPopup1
            handleCloseAssignMentor={handleCloseAssignMentor}
            openAssignMentor={openAssignMentor}
            action={action}
            handleOpenFindmentor={handleOpenFindmentor}
            matchingFields={matchingFields}
            setMatchingFields={setMatchingFields}
            handleSubmitAutoMatch={handleSubmitAutoMatch}
            maxMatchCountMentee={maxMatchCountMentee}
            maxMatchCountMentor={maxMatchCountMentor}
            setMatchCountMentee={setMatchCountMentee}
            setMatchCountMentor={setMatchCountMentor}
            loaderFirstPopup={loaderFirstPopup}
            selectMentors={
              <SelectMentors
                memberList={member}
                hasAnyTrueValue={hasAnyTrueValue}
                assignIdFunction={assignIdFunction}
                setSelectValueMentor={setSelectValueMentor}
                setMentorId={setMentorId}
                setMenteeId={setMenteeId}
              />
            }
            selectValueMentor={selectValueMentor}
          />

          {/* Assign a mentor second popup */}
          <AssignMatchPopup2
            openAssignMentorSecond={openAssignMentorSecond}
            handelCloseAssineMatch={handelCloseAssineMatch}
            action={action}
            recommendations={recommendations}
            suggestions={suggestions}
            setSelectedRecommendation={setSelectedRecommendation}
            handleSubmitAssignMatch={handleSubmitAssignMatch}
            loaderFirstPopup={loaderFirstPopup}
          />

          {/* Matches confirmation popup code */}
          <ConfirmationPopup
            matchesCount={matchesCount}
            confirmedCount={confirmedCount}
            modelConfirmMatch={modelConfirmMatch}
            handleCloseConfirmMatch={handleCloseConfirmMatch}
            handelSubmitConfirmMatch={handelSubmitConfirmMatch}
            handleConfirmAll={handleConfirmAll}
            loaderFirstPopup={loaderFirstPopup}
            loaderFirstPopup1={loaderFirstPopup1}
          />

          {/* Match details popup */}
          <MatchDetailsPopup
            openMatchDetails={openMatchDetails}
            handleCloseMatchDetails={handleCloseMatchDetails}
            matchDetails={matchDetails}
            matchDetailsLoader={matchDetailsLoader}
            matchId={confirmMatchId}
            // The row's own status, by the rule the row uses: getMatchProfile sends no status, and the
            // popup labelled every match "Ongoing", pending and ended ones included.
            statusLabel={
              matchSingle?.matchStatus === 'Inactive' ? 'Ended' : matchSingle?.isConfirmed ? 'Ongoing' : matchSingle ? 'Pending' : undefined
            }
          />

          <MatchReasoningPopup
            open={openMatchReasoning}
            handleClose={handleCloseMatchReasoning}
            match={matchSingle}
          />

          {/* Match delete popup */}
          <MatchDeleteDialog
            openDelete={openDelete}
            setOpenDelete={setOpenDelete}
            deleteLoader={deleteLoader}
            handeleDeleteMatch={handeleDeleteMatch}
          />

          {openRecruitMentor && (
            <RecruitNewMentor
            origin='admin'
              open={openRecruitMentor}
              onClose={handleCloseRecruitMentor}
              mentorsList={[]}
              onProfileClick={(mid: any) => {
                handelOpenProfile(mid);
              }}
              onChatClick={(mentor: any) => {
              }}
              onCalendarClick={(mentor: any) => {
              }}
              objId=""
              grpId={grpId !== 'admin' ? grpId : coId}
              isAssignPopup={isAssignPopup}
              assigneeRole={action}
              userId={userId}
              onSelect={(selectedMenteeId: any) => {
                setMenteeId(selectedMenteeId);
              }}
              dataArray={dataArray}
              setDataArray={setDataArray}
              apiType="match"
            />
          )}

          <Modal open={openManualInvite} onClose={handleCloseManualInvite}>
            <Box
              sx={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2
              }}
            >
              <Box
                sx={{
                  width: 550,
                  bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
                  borderRadius: '8px',
                  outline: '1px solid var(--Stroke-Modal-border, #444444)',
                  outlineOffset: '-1px',
                  display: 'inline-flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  overflow: 'hidden',
                  fontFamily: 'Inter, sans-serif',
                  color: 'var(--Text-text-primary, #FDFDFD)'
                }}
              >
                <Box
                  data-show-left-icon="false"
                  data-show-x="true"
                  data-style="Stroke"
                  data-type="Left"
                  sx={{
                    width: 550,
                    pl: '24px',
                    pr: '44px',
                    py: '20px',
                    position: 'relative',
                    borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                    display: 'inline-flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: '20px'
                  }}
                >
                  <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '5px' }}>
                    <Box sx={{ flex: 1, color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 18, fontWeight: 700 }}>
                      Assign Match(es)
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      p: '6px',
                      left: '503px',
                      top: '20px',
                      position: 'absolute',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      color: 'var(--Stroke-icon-highlight, #FDFDFD)'
                    }}
                    onClick={handleCloseManualInvite}
                  >
                    <CloseIcon sx={{ fontSize: 20 }} />
                  </Box>
                </Box>
                <Box
                  sx={{
                    alignSelf: 'stretch',
                    p: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '28px',
                    overflow: 'hidden'
                  }}
                >
                  <Box
                    data-3="false"
                    data-4="false"
                    data-5="false"
                    data-6="false"
                    data-7="false"
                    data-8="false"
                    data-size="Default"
                    sx={{
                      alignSelf: 'stretch',
                      borderRadius: '6px',
                      display: 'inline-flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      overflow: 'hidden'
                    }}
                  >
                    <Box
                      data-size="Default"
                      data-state={manualInviteTab === 'auto' ? 'selected' : 'default'}
                      sx={{
                        flex: 1,
                        px: '16px',
                        py: '8px',
                        background:
                          manualInviteTab === 'auto'
                            ? 'var(--Fill-Tab-tab-selected, #F79420)'
                            : 'var(--Fill-Tab-tab-default, #2A2A2A)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => setManualInviteTab('auto')}
                    >
                      <Box
                        sx={{
                          color:
                            manualInviteTab === 'auto'
                              ? 'var(--Stroke-solid-white, #FFFFFF)'
                              : 'var(--Stroke-Tab-tab-default, #B6B6B6)',
                          fontSize: 12,
                          fontWeight: manualInviteTab === 'auto' ? 700 : 400
                        }}
                      >
                        {/* Auto-suggested ({autoSuggestedCount}) */}
                        Auto-suggested
                      </Box>
                    </Box>
                    <Box
                      data-size="Default"
                      data-state={manualInviteTab === 'manual' ? 'selected' : 'default'}
                      sx={{
                        flex: 1,
                        px: '16px',
                        py: '8px',
                        background:
                          manualInviteTab === 'manual'
                            ? 'var(--Fill-Tab-tab-selected, #F79420)'
                            : 'var(--Fill-Tab-tab-default, #2A2A2A)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => setManualInviteTab('manual')}
                    >
                      <Box
                        sx={{
                          color:
                            manualInviteTab === 'manual'
                              ? 'var(--Stroke-solid-white, #FFFFFF)'
                              : 'var(--Stroke-Tab-tab-default, #B6B6B6)',
                          fontSize: 12,
                          fontWeight: manualInviteTab === 'manual' ? 700 : 400
                        }}
                      >
                        Manual Search
                      </Box>
                    </Box>
                    {isAiMatchingEnabled && (
                      <Box
                        data-size="Default"
                        data-state={manualInviteTab === 'ai' ? 'selected' : 'default'}
                        sx={{
                          flex: 1,
                          px: '16px',
                          py: '8px',
                          background:
                            manualInviteTab === 'ai'
                              ? 'var(--Fill-Tab-tab-selected, #F79420)'
                              : 'var(--Fill-Tab-tab-default, #2A2A2A)',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: '6px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setManualInviteTab('ai');
                          if (aiRecommendations.length === 0 && !aiLoading) {
                            handleFetchAIRecommendations();
                          }
                        }}
                      >
                        <Box
                          sx={{
                            color:
                              manualInviteTab === 'ai'
                                ? 'var(--Stroke-solid-white, #FFFFFF)'
                                : 'var(--Stroke-Tab-tab-default, #B6B6B6)',
                            fontSize: 12,
                            fontWeight: manualInviteTab === 'ai' ? 700 : 400,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}
                        >
                          <AutoAwesomeIcon sx={{ fontSize: 14 }} />
                          Match with Elliott
                        </Box>
                      </Box>
                    )}
                  </Box>

                  {manualInviteTab === 'manual' && (
                    <Box
                      data-helper-text="false"
                      data-label-position="Top"
                      data-show-inner-icon="true"
                      data-show-label="true"
                      data-size="Small"
                      data-state="completed"
                      data-type="Text"
                      sx={{
                        alignSelf: 'stretch',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: '6px'
                      }}
                    >
                      <Box sx={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: '4px' }}>
                        <Box sx={{ alignSelf: 'stretch', color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>
                          Search Program Participant:
                        </Box>
                        <Box sx={{ alignSelf: 'stretch' }}>
                          <DosenInput
                            value={manualSearchValue}
                            onChange={(event) => setManualSearchValue(event.target.value)}
                            placeholder="Search here"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchOutlinedIcon sx={{ color: 'var(--Stroke-icon-dim, #868686)', fontSize: 16 }} />
                                </InputAdornment>
                              )
                            }}
                            // inputSx={{
                            //   '& .MuiOutlinedInput-root': {
                            //     backgroundColor: 'var(--Fill-Transparent-trans-normal-7, rgba(255,255,255,0.07)) !important',
                            //     borderRadius: '6px',
                            //     '& fieldset': {
                            //       borderColor: 'var(--Stroke-Border-border-highlight, #F79420) !important'
                            //     },
                            //     '&:hover fieldset': {
                            //       borderColor: 'var(--Stroke-Border-border-highlight, #F79420) !important'
                            //     },
                            //     '&.Mui-focused fieldset': {
                            //       borderColor: 'var(--Stroke-Border-border-highlight, #F79420) !important'
                            //     }
                            //   },
                            //   '& .MuiInputBase-input': {
                            //     padding: '8px 12px'
                            //   }
                            // }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {manualInviteTab === 'ai' && (
                    <Box sx={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'column', gap: '16px', maxHeight: 420, overflowY: 'auto' }}>
                      {aiLoading && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 220 }}>
                          <ElliottWorking size="full" message="Elliott is finding the best matches..." />
                          <Box sx={{ color: '#B6B6B6', fontSize: 12, textAlign: 'center', maxWidth: 320 }}>
                            This can take up to a minute while Elliott reviews each candidate.
                          </Box>
                        </Box>
                      )}

                      {!aiLoading && aiErrorMessage && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', py: 4 }}>
                          <Box sx={{ color: '#FF6B6B', fontSize: 13, textAlign: 'center' }}>
                            {aiErrorMessage}
                          </Box>
                          <DosenButton
                            tone="basic"
                            sizeVariant="sm"
                            onClick={() => handleFetchAIRecommendations()}
                          >
                            Try Again
                          </DosenButton>
                        </Box>
                      )}

                      {!aiLoading && !aiErrorMessage && aiRecommendations.length === 0 && (
                        <Box sx={{ color: '#B6B6B6', fontSize: 14, textAlign: 'center', py: 4 }}>
                          {aiEmptyMessage || 'No suggestions from Elliott available.'}
                        </Box>
                      )}

                      {!aiLoading && !aiErrorMessage && aiRecommendations.map((rec: any, idx: number) => {
                        const name = rec.name || rec.displayName || 'Member';
                        const avatar = rec.image || rec.headshot;
                        const id = manualTriggerRole === 'Mentee' ? rec.mentorId : rec.menteeId;
                        const score = typeof rec.aiScore === 'number' ? rec.aiScore : null;
                        const scoreColor = score !== null
                          ? (score >= 85 ? '#4CAF50' : score >= 70 ? '#F79420' : '#B6B6B6')
                          : '#B6B6B6';
                        const cardKey = String(id ?? idx);
                        const isExpanded = !!expandedAiCards[cardKey];
                        return (
                          <Box key={id || idx} sx={{
                            display: 'flex', flexDirection: 'column', gap: '10px',
                            p: '16px', borderRadius: '8px',
                            border: '1px solid #2A2A2A', background: '#1A1A1A'
                          }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                                {avatar ? (
                                  <img src={avatar} alt={name} style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover' }} />
                                ) : (
                                  <Box sx={{ width: 48, height: 48, borderRadius: '50%', background: '#F79420', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 16 }}>
                                    {name.slice(0, 1).toUpperCase()}
                                  </Box>
                                )}
                                {id && (
                                  <Checkbox
                                    checked={selectedAiCandidateIds.includes(id)}
                                    onChange={() => toggleAiCandidate(id)}
                                    sx={{ color: '#B6B6B6', p: 0, flexShrink: 0, '&.Mui-checked': { color: '#F79420' } }}
                                    inputProps={{ 'aria-label': `Select ${name}` }}
                                  />
                                )}
                              </Box>
                              <Box sx={{ flex: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                  <Box sx={{ color: '#FDFDFD', fontSize: 16, fontWeight: 700 }}>{name}</Box>
                                  {score !== null && (
                                    <Box sx={{
                                      px: '8px', py: '2px', borderRadius: '20px',
                                      border: `1px solid ${scoreColor}`,
                                      background: `${scoreColor}14`,
                                      display: 'flex', alignItems: 'center', gap: '4px'
                                    }}>
                                      <Box sx={{ color: scoreColor, fontSize: 12, fontWeight: 600 }}>{score}%</Box>
                                    </Box>
                                  )}
                                </Box>
                                {(rec.aiOverallAssessment || rec.aiReasoning) && (
                                  <Box sx={{ color: '#FDFDFD', fontSize: 13, lineHeight: 1.5, mt: 0.75 }}>
                                    {rec.aiOverallAssessment || rec.aiReasoning}
                                  </Box>
                                )}
                              </Box>
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                                {id && (
                                  <DosenButton
                                    iconOnly
                                    tone="basic"
                                    sizeVariant="sm"
                                    onClick={() => handleOpenMenteeProfileModal(id)}
                                    sx={{
                                      width: 36,
                                      height: 36,
                                      minWidth: 36,
                                      borderRadius: '9999px',
                                      padding: '5px',
                                      background: '#F79420',
                                      flexShrink: 0,
                                      '&:hover': { background: '#F79420', opacity: 0.9 }
                                    }}
                                    aria-label="View profile"
                                  >
                                    <AccountCircleOutlinedIcon sx={{ color: '#FFFFFF', fontSize: 18 }} />
                                  </DosenButton>
                                )}
                                {Array.isArray(rec.aiFieldComparisons) && rec.aiFieldComparisons.length > 0 && (
                                  <DosenTooltip
                                    title={isExpanded ? 'Hide field-by-field reasoning' : 'See field-by-field reasoning'}
                                    placement="left"
                                  >
                                    <IconButton
                                      onClick={() =>
                                        setExpandedAiCards((prev) => ({ ...prev, [cardKey]: !prev[cardKey] }))
                                      }
                                      aria-label={isExpanded ? 'Hide field-by-field reasoning' : 'See field-by-field reasoning'}
                                      sx={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: '9999px',
                                        border: `1px solid ${isExpanded ? '#F79420' : '#2A2A2A'}`,
                                        background: isExpanded ? 'rgba(247,148,32,0.13)' : 'transparent',
                                        flexShrink: 0,
                                        '&:hover': { background: 'rgba(247,148,32,0.18)' }
                                      }}
                                    >
                                      <AutoAwesomeIcon sx={{ fontSize: 18, color: '#F79420' }} />
                                    </IconButton>
                                  </DosenTooltip>
                                )}
                              </Box>
                            </Box>

                            {isExpanded && Array.isArray(rec.aiFieldComparisons) && rec.aiFieldComparisons.length > 0 && (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                {rec.aiFieldComparisons.map((cmp: AIFieldComparison, cmpIdx: number) => (
                                  <Box key={`${cmp.field}-${cmpIdx}`} sx={{
                                    p: '10px', borderRadius: '6px',
                                    background: '#0F0F0F', border: '1px solid #2A2A2A'
                                  }}>
                                    <Box sx={{ color: '#FDFDFD', fontSize: 12, fontWeight: 600, mb: '2px' }}>
                                      {cmp.field}
                                    </Box>
                                    <Box sx={{ color: '#B6B6B6', fontSize: 12, lineHeight: 1.5 }}>
                                      {cmp.reasoning}
                                    </Box>
                                  </Box>
                                ))}
                              </Box>
                            )}

                          </Box>
                        );
                      })}
                    </Box>
                  )}

                  <Box sx={{ alignSelf: 'stretch', height: manualInviteTab === 'ai' ? 0 : 208, display: manualInviteTab === 'ai' ? 'none' : 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '10px', overflow: 'hidden' }}>
                    {manualInviteTab === 'manual' && (
                      <Box sx={{ color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 14, fontWeight: 700, lineHeight: '20px' }}>
                        Search Results ({filteredManualCandidates.length}):
                      </Box>
                    )}
                    <Box
                      onScroll={handleManualListScroll}
                      sx={{
                        alignSelf: 'stretch',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: '20px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        width: '100%'
                      }}
                    >
                      {manualInviteTab === 'auto' && autoSuggestionsLoading ? (
                        <Box sx={{ flex: 1, width: '100%', minHeight: 280, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Box aria-busy aria-label="Loading" sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {Array.from({ length: 4 }, (_, i) => (
                              <Bone key={i} height={56} />
                            ))}
                          </Box>
                        </Box>
                      ) : null}
                      {manualInviteTab === 'auto' && !autoSuggestionsLoading && autoSuggestedMentees.length === 0 ? (
                        <Box sx={{ color: 'var(--Text-text-secondary, #B6B6B6)', fontSize: 14, fontWeight: 400 }}>
                          {autoSuggestionsError || 'No suggestions available.'}
                        </Box>
                      ) : null}
                      {manualInviteTab === 'manual' && filteredManualCandidates.length === 0 ? (
                        <Box sx={{ color: 'var(--Text-text-secondary, #B6B6B6)', fontSize: 14, fontWeight: 400 }}>
                          No {w(manualTriggerRole === 'Mentee' ? 'mentor' : 'mentee', { plural: true, lower: true })} found.
                        </Box>
                      ) : null}
                      {!(manualInviteTab === 'auto' && autoSuggestionsLoading) && visibleMentees.map((mentee) => {
                          const selectedObjectives = selectedObjectivesByCandidate[mentee.id] || [];
                          const autoObjectiveSource = manualInviteTab === 'auto' ? mentee.matchedObjectives || [] : [];
                          const autoObjectives = Array.isArray(autoObjectiveSource)
                            ? autoObjectiveSource.map((obj: any, index: number) => {
                                if (typeof obj === 'string') {
                                  return { id: obj, objective: obj };
                                }
                                return {
                                  id: obj?.id || obj?._id || obj?.objectiveId || obj?.value || `${mentee.id}-obj-${index}`,
                                  objective: obj?.objective || obj?.title || obj?.name || obj?.label || 'Objective'
                                };
                              })
                            : [];
                          const objectivesToRender = manualInviteTab === 'auto' && autoObjectives.length > 0 ? autoObjectives : learningObjectives;
                          const menteeInitials = (mentee.displayName || '')
                            .split(' ')
                            .filter(Boolean)
                            .slice(0, 2)
                            .map((part: string) => part[0]?.toUpperCase() || '')
                            .join('');
                          return (
                            <Box key={mentee.id} sx={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: '5px' }}>
                              <Box sx={{ alignSelf: 'stretch', display: 'inline-flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px' }}>
                                <Box data-show-tag="true" data-show-title="true" data-size="Default" sx={{ flex: 1, height: 48, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px' }}>
                                  {mentee.headshot ? (
                                    <Box data-state="Logged In - Pic" sx={{ width: 48, height: 48, position: 'relative', borderRadius: '9999px' }}>
                                      <Box data-person="Mentee" sx={{ width: 48, height: 48, left: 0, top: 0, position: 'absolute' }}>
                                        <img
                                          style={{ width: 48, height: 48, left: 0, top: 0, position: 'absolute', borderRadius: '9999px' }}
                                          src={mentee.headshot}
                                          alt={mentee.displayName}
                                          loading="lazy"
                                          decoding="async"
                                        />
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Box data-state="Logged In - No Pic" sx={{ width: 48, height: 48, position: 'relative', borderRadius: '9999px' }}>
                                      <Box sx={{ width: 48, height: 48, left: 0, top: 0, position: 'absolute', background: 'var(--Brand-light, #F79420)', borderRadius: '9999px' }} />
                                      <Box sx={{ left: '10px', top: '10.5px', position: 'absolute', textAlign: 'center', color: 'var(--Stroke-solid-white, #FFFFFF)', fontSize: 16, fontWeight: 500, lineHeight: '28px' }}>
                                        {menteeInitials || 'NA'}
                                      </Box>
                                    </Box>
                                  )}
                                  <Box sx={{ flex: 1, py: '8px', display: 'inline-flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: '3px' }}>
                                    <Box sx={{ alignSelf: 'stretch', display: 'inline-flex', justifyContent: 'flex-start', alignItems: 'center', gap: '5px' }}>
                                      <Box sx={{ color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 16, fontWeight: 700, lineHeight: '16px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {mentee.displayName}
                                      </Box>
                                      <Box
                                        data-color="Light Blue"
                                        data-show-icon="true"
                                        data-size="Small"
                                        data-style="Stroke"
                                        data-type="Default"
                                        sx={{
                                          px: '8px',
                                          py: '3px',
                                          borderRadius: '20px',
                                          outline: '1px solid #3B82F6',
                                          outlineOffset: '-1px',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center'
                                        }}
                                      >
                                      <Box sx={{ color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 12, fontWeight: 400, lineHeight: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                          {isMemberRole(mentee.role)
                                            ? w(mentee.role.trim().toLowerCase() as MemberRoleCode)
                                            : _.startCase(mentee.role || '') || 'Member'}
                                      </Box>
                                    </Box>
                                    <Box sx={{ color: 'var(--Text-text-secondary, #B6B6B6)', fontSize: 12, fontWeight: 500, lineHeight: '12px' }}>
                                      Matches: {mentee.matchCount ?? 0}
                                    </Box>
                                  </Box>
                                    <Box sx={{ alignSelf: 'stretch', height: 12, color: 'var(--Text-text-secondary, #B6B6B6)', fontSize: 12, fontWeight: 500, lineHeight: '12px' }}>
                                      {mentee.title && mentee.company
                                        ? `${mentee.title}, ${mentee.company}`
                                        : mentee.title || mentee.company || ''}
                                    </Box>
                                  </Box>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '14px' }}>
                                  <DosenButton
                                    iconOnly
                                    tone="basic"
                                    sizeVariant="sm"
                                    onClick={() => handleOpenMenteeProfileModal(getMemberId(mentee))}
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      minWidth: 40,
                                      borderRadius: '9999px',
                                      padding: '5px',
                                      background: '#F79420',
                                      '&:hover': {
                                        background: '#F79420',
                                        opacity: 0.9
                                      }
                                    }}
                                    aria-label="View profile"
                                  >
                                    <AccountCircleOutlinedIcon sx={{ color: '#FFFFFF' }} />
                                  </DosenButton>
                                </Box>
                              </Box>
                              <Box sx={{ alignSelf: 'stretch', pl: '56px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: '5px' }}>
                                {objectivesToRender.length === 0 ? (
                                  <Box sx={{ color: 'var(--Text-text-secondary, #B6B6B6)', fontSize: 14, fontWeight: 400, lineHeight: '20px' }}>
                                    {manualTriggerRole === 'Mentee'
                                      ? 'No areas of expertise available.'
                                      : 'No learning objectives available.'}
                                  </Box>
                                ) : (
                                  objectivesToRender.map((objective) => {
                                    const isChecked = selectedObjectives.includes(objective.id);
                                    return (
                                      <label
                                        key={`${mentee.id}-${objective.id}`}
                                        data-show-label="true"
                                        data-state={isChecked ? 'Check-All' : 'Default'}
                                        style={{
                                          display: 'inline-flex',
                                          justifyContent: 'flex-start',
                                          alignItems: 'center',
                                          gap: '10px',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
                                          checked={isChecked}
                                          onChange={() => handleToggleObjective(mentee.id, objective.id)}
                                        />
                                        <Box sx={{ width: 20, height: 20, p: '3px', position: 'relative', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
                                          <Box
                                            sx={{
                                              width: 16,
                                              height: 16,
                                              left: '2.75px',
                                              top: '2.75px',
                                              position: 'absolute',
                                              background: 'var(--Fill-Transparent-trans-normal-9, rgba(255,255,255,0.09))',
                                              borderRadius: '3px',
                                              outline: `2px solid ${
                                                isChecked
                                                  ? 'var(--Stroke-solid-white, #FFFFFF)'
                                                  : 'var(--Stroke-Form-Input-border-light, #2A2A2A)'
                                              }`,
                                              outlineOffset: '-1px'
                                            }}
                                          />
                                          {isChecked && (
                                            <CheckIcon
                                              sx={{
                                                position: 'absolute',
                                                left: '55%',
                                                top: '55%',
                                                transform: 'translate(-50%, -50%)',
                                                fontSize: 12,
                                                color: 'var(--Stroke-solid-white, #FFFFFF)'
                                              }}
                                            />
                                          )}
                                        </Box>
                                        <Box sx={{ color: isChecked ? 'var(--Text-text-primary, #FDFDFD)' : 'var(--Text-text-secondary, #B6B6B6)', fontSize: 14, fontWeight: 400, lineHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                          {objective.objective}
                                        </Box>
                                      </label>
                                    );
                                  })
                                )}
                              </Box>
                            </Box>
                          );
                        })
                      }
                    </Box>
                  </Box>

                  <Box sx={{ alignSelf: 'stretch', display: 'inline-flex', justifyContent: 'center', alignItems: 'center', gap: '14px' }}>
                    <DosenButton
                      type="button"
                      onClick={manualInviteTab === 'ai' ? handleAssignAiMatches : handleManualAssignMatches}
                      loading={manualAssignLoading}
                      loadingText="Assigning..."
                      disabled={manualInviteTab === 'ai' && selectedAiCandidateIds.length === 0}
                      sizeVariant="sm"
                      tone="cta"
                      data-color="Default"
                      data-icon-place="None"
                      data-show-text="true"
                      data-size="Small"
                      data-state="Default"
                      data-style="Filled"
                      data-type="CTA"
                      sx={{
                        flex: 1,
                        maxWidth: '192px',
                        padding: '10px 14px',
                        borderRadius: '6px'
                      }}
                    >
                      Assign Match(es)
                    </DosenButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Modal>

          <MenteeProfileModal
            open={openMenteeProfileModal}
            onClose={handleCloseMenteeProfileModal}
            user={profileModalUser || {}}
            matcheeUser={matcheeProfileUser}
            candidateLabel={`${manualTriggerRole === 'Mentee' ? w('mentor') : w('mentee')} Profile`}
            matcheeLabel={`${manualTriggerRole === 'Mentee' ? w('mentee') : w('mentor')} Profile`}
          />

          {/* MatchFilter */}
    </>
  );
};

export default MatchesMainPage;
